/* stylelint-disable */
// legacy/packages/portal/src/designs/css/ui.cssのstyleをコピーしたもの
// theoplayerのベースのスタイルを定義するためのコード
// 条件付きで適用するために、linkタグではなく、CSS-in-JSで定義

import { css } from "@emotion/core";

export const THEOPLAYER_BASE_STYLE = css`
  @font-face {
    font-family: THEOplayer;
    src:
      url(data:application/font-woff;charset=utf-8;base64,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)
        format("woff"),
      url(data:application/x-font-ttf;charset=utf-8;base64,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)
        format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-play,
  .video-js .vjs-play-control,
  .video-js .vjs-big-play-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-play:before,
  .video-js .vjs-play-control:before,
  .video-js .vjs-big-play-button:before {
    content: "\f101";
  }
  .vjs-icon-play-circle {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-play-circle:before {
    content: "\f102";
  }
  .vjs-icon-pause,
  .video-js .vjs-play-control.vjs-playing {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-pause:before,
  .video-js .vjs-play-control.vjs-playing:before {
    content: "\f103";
  }
  .vjs-icon-volume-mute,
  .video-js .vjs-mute-control.vjs-vol-0,
  .video-js .vjs-volume-menu-button.vjs-vol-0 {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-volume-mute:before,
  .video-js .vjs-mute-control.vjs-vol-0:before,
  .video-js .vjs-volume-menu-button.vjs-vol-0:before {
    content: "\f104";
  }
  .vjs-icon-volume-low,
  .video-js .vjs-mute-control.vjs-vol-1,
  .video-js .vjs-volume-menu-button.vjs-vol-1 {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-volume-low:before,
  .video-js .vjs-mute-control.vjs-vol-1:before,
  .video-js .vjs-volume-menu-button.vjs-vol-1:before {
    content: "\f105";
  }
  .vjs-icon-volume-mid,
  .video-js .vjs-mute-control.vjs-vol-2,
  .video-js .vjs-volume-menu-button.vjs-vol-2 {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-volume-mid:before,
  .video-js .vjs-mute-control.vjs-vol-2:before,
  .video-js .vjs-volume-menu-button.vjs-vol-2:before {
    content: "\f106";
  }
  .vjs-icon-volume-high,
  .video-js .vjs-mute-control,
  .video-js .vjs-volume-menu-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-volume-high:before,
  .video-js .vjs-mute-control:before,
  .video-js .vjs-volume-menu-button:before {
    content: "\f107";
  }
  .vjs-icon-fullscreen-enter,
  .video-js .vjs-fullscreen-control {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-fullscreen-enter:before,
  .video-js .vjs-fullscreen-control:before {
    content: "\f108";
  }
  .vjs-icon-fullscreen-exit,
  .video-js.vjs-fullscreen .vjs-fullscreen-control {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-fullscreen-exit:before,
  .video-js.vjs-fullscreen .vjs-fullscreen-control:before {
    content: "\f109";
  }
  .vjs-icon-square {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-square:before {
    content: "\f10a";
  }
  .vjs-icon-spinner {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-spinner:before {
    content: "\f10b";
  }
  .vjs-icon-subtitles,
  .video-js .vjs-subtitles-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-subtitles:before,
  .video-js .vjs-subtitles-button:before {
    content: "\f10c";
  }
  .vjs-icon-captions,
  .video-js .vjs-captions-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-captions:before,
  .video-js .vjs-captions-button:before {
    content: "\f10d";
  }
  .vjs-icon-chapters,
  .video-js .vjs-chapters-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-chapters:before,
  .video-js .vjs-chapters-button:before {
    content: "\f10e";
  }
  .vjs-icon-share {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-share:before {
    content: "\f10f";
  }
  .vjs-icon-cog {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-cog:before {
    content: "\f110";
  }
  .vjs-icon-circle,
  .theoplayer-skin .theo-live-control-indicator,
  .video-js .vjs-volume-level,
  .video-js .vjs-play-progress,
  .video-js .vjs-mouse-display {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-circle:before,
  .theoplayer-skin .theo-live-control-indicator:before,
  .video-js .vjs-volume-level:before,
  .video-js .vjs-play-progress:before,
  .video-js .vjs-mouse-display:before {
    content: "\f111";
  }
  .vjs-icon-circle-outline {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-circle-outline:before {
    content: "\f112";
  }
  .vjs-icon-circle-inner-circle {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-circle-inner-circle:before {
    content: "\f113";
  }
  .vjs-icon-hd {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-hd:before {
    content: "\f114";
  }
  .vjs-icon-cancel,
  .video-js .vjs-control.vjs-close-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-cancel:before,
  .video-js .vjs-control.vjs-close-button:before {
    content: "\f115";
  }
  .vjs-icon-replay,
  .theoplayer-skin.vjs-ended .vjs-play-control {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-replay:before,
  .theoplayer-skin.vjs-ended .vjs-play-control:before {
    content: "\f116";
  }
  .vjs-icon-facebook {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-facebook:before {
    content: "\f117";
  }
  .vjs-icon-gplus {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-gplus:before {
    content: "\f118";
  }
  .vjs-icon-linkedin {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-linkedin:before {
    content: "\f119";
  }
  .vjs-icon-twitter {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-twitter:before {
    content: "\f11a";
  }
  .vjs-icon-tumblr {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-tumblr:before {
    content: "\f11b";
  }
  .vjs-icon-pinterest {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-pinterest:before {
    content: "\f11c";
  }
  .vjs-icon-audio-description,
  .video-js .vjs-descriptions-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-audio-description:before,
  .video-js .vjs-descriptions-button:before {
    content: "\f11d";
  }
  .vjs-icon-audio,
  .video-js .vjs-audio-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-audio:before,
  .video-js .vjs-audio-button:before {
    content: "\f11e";
  }
  .vjs-icon-next-item {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-next-item:before {
    content: "\f11f";
  }
  .vjs-icon-previous-item {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-previous-item:before {
    content: "\f120";
  }
  .vjs-icon-picture-in-picture {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-picture-in-picture:before {
    content: "\f121";
  }
  .vjs-icon-picture-in-picture-enter {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-picture-in-picture-enter:before {
    content: "\f122";
  }
  .vjs-icon-picture-in-picture-exit {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-picture-in-picture-exit:before {
    content: "\f123";
  }
  .vjs-icon-view-module {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-view-module:before {
    content: "\f124";
  }
  .vjs-icon-close,
  .theoplayer-skin .theo-close-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-close:before,
  .theoplayer-skin .theo-close-button:before {
    content: "\f125";
  }
  .vjs-icon-cardboard,
  .theoplayer-skin .theo-vr-button {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-cardboard:before,
  .theoplayer-skin .theo-vr-button:before {
    content: "\f126";
  }
  .vjs-icon-view-grid {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-view-grid:before {
    content: "\f127";
  }
  .vjs-icon-multi-view {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-multi-view:before {
    content: "\f128";
  }
  .vjs-icon-expand-less {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-expand-less:before {
    content: "\f129";
  }
  .vjs-icon-expand-more {
    font-family: THEOplayer;
    font-weight: normal;
    font-style: normal;
  }
  .vjs-icon-expand-more:before {
    content: "\f12a";
  }
  .vjs-modal-dialog .vjs-modal-dialog-content,
  .video-js .vjs-modal-dialog,
  .video-js .vjs-control:before,
  .video-js .vjs-big-play-button:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .video-js .vjs-control:before,
  .video-js .vjs-big-play-button:before {
    text-align: center;
  }
  .video-js {
    display: block;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    background-color: #000;
    position: relative;
    padding: 0;
    font-size: 10px;
    line-height: 1;
    font-weight: normal;
    font-style: normal;
    font-family: Arial, Helvetica, sans-serif;
  }
  .video-js:-moz-full-screen {
    position: absolute;
  }
  .video-js:-webkit-full-screen {
    width: 100% !important;
    height: 100% !important;
  }
  .video-js *,
  .video-js *:before,
  .video-js *:after {
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
  }
  .video-js ul {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    list-style-position: outside;
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    margin-bottom: 0;
  }
  .video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    width: 100%;
    max-width: 100%;
    height: 0;
  }
  .video-js.vjs-16-9 {
    padding-top: 56.25%;
  }
  .video-js.vjs-4-3 {
    padding-top: 75%;
  }
  .video-js.vjs-fill {
    width: 100%;
    height: 100%;
  }
  .video-js .vjs-tech {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  body.vjs-full-window {
    padding: 0;
    margin: 0;
    height: 100%;
    overflow-y: auto;
  }
  .vjs-full-window .video-js.vjs-fullscreen {
    position: fixed;
    overflow: hidden;
    z-index: 1000;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  .video-js.vjs-fullscreen {
    width: 100% !important;
    height: 100% !important;
    padding-top: 0 !important;
  }
  .video-js.vjs-fullscreen.vjs-user-inactive {
    cursor: none;
  }
  .vjs-hidden {
    display: none !important;
  }
  .vjs-disabled {
    opacity: 0.5;
    cursor: default;
  }
  .video-js .vjs-offscreen {
    height: 1px;
    left: -9999px;
    position: absolute;
    top: 0;
    width: 1px;
  }
  .vjs-lock-showing {
    display: block !important;
    opacity: 1;
    visibility: visible;
  }
  .vjs-no-js {
    padding: 20px;
    color: #fff;
    background-color: #000;
    font-size: 18px;
    font-family: Arial, Helvetica, sans-serif;
    text-align: center;
    width: 300px;
    height: 150px;
    margin: 0px auto;
  }
  .vjs-no-js a,
  .vjs-no-js a:visited {
    color: #66a8cc;
  }
  .video-js .vjs-big-play-button {
    font-size: 3em;
    line-height: 1.5em;
    height: 1.5em;
    width: 3em;
    display: block;
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 0;
    cursor: pointer;
    opacity: 1;
    border: 0.06666em solid #fff;
    background-color: #2b333f;
    background-color: rgba(43, 51, 63, 0.7);
    border-radius: 0.3em;
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s;
  }
  .vjs-big-play-centered .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-top: -0.75em;
    margin-left: -1.5em;
  }
  .video-js:hover .vjs-big-play-button,
  .video-js .vjs-big-play-button:focus {
    outline: 0;
    border-color: #fff;
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
    -webkit-transition: all 0s;
    -moz-transition: all 0s;
    transition: all 0s;
  }
  .vjs-controls-disabled .vjs-big-play-button,
  .vjs-has-started .vjs-big-play-button,
  .vjs-using-native-controls .vjs-big-play-button,
  .vjs-error .vjs-big-play-button {
    display: none;
  }
  .vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause
    .vjs-big-play-button {
    display: block;
  }
  .video-js button {
    background: none;
    border: none;
    color: inherit;
    display: inline-block;
    overflow: visible;
    font-size: inherit;
    line-height: inherit;
    text-transform: none;
    text-decoration: none;
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .video-js .vjs-control.vjs-close-button {
    cursor: pointer;
    height: 3em;
    position: absolute;
    right: 0;
    top: 0.5em;
    z-index: 2;
  }
  .vjs-menu-button {
    cursor: pointer;
  }
  .vjs-menu-button.vjs-disabled {
    cursor: default;
  }
  .vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu {
    display: none;
  }
  .vjs-menu .vjs-menu-content {
    display: block;
    padding: 0;
    margin: 0;
    overflow: auto;
    font-family: Arial, Helvetica, sans-serif;
  }
  .vjs-scrubbing .vjs-menu-button:hover .vjs-menu {
    display: none;
  }
  .vjs-menu li {
    list-style: none;
    margin: 0;
    padding: 0.2em 0;
    line-height: 1.4em;
    font-size: 1.2em;
    text-align: center;
    text-transform: lowercase;
  }
  .vjs-menu li.vjs-menu-item:focus,
  .vjs-menu li.vjs-menu-item:hover {
    outline: 0;
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
  }
  .vjs-menu li.vjs-selected,
  .vjs-menu li.vjs-selected:focus,
  .vjs-menu li.vjs-selected:hover {
    background-color: #fff;
    color: #2b333f;
  }
  .vjs-menu li.vjs-menu-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 1em;
    line-height: 2em;
    padding: 0;
    margin: 0 0 0.3em 0;
    font-weight: bold;
    cursor: default;
  }
  .vjs-menu-button-popup .vjs-menu {
    display: none;
    position: absolute;
    bottom: 0;
    width: 10em;
    left: -3em;
    height: 0em;
    margin-bottom: 1.5em;
    border-top-color: rgba(43, 51, 63, 0.7);
  }
  .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
    background-color: #2b333f;
    background-color: rgba(43, 51, 63, 0.7);
    position: absolute;
    width: 100%;
    bottom: 1.5em;
    max-height: 15em;
  }
  .vjs-workinghover .vjs-menu-button-popup:hover .vjs-menu,
  .vjs-menu-button-popup .vjs-menu.vjs-lock-showing {
    display: block;
  }
  .video-js .vjs-menu-button-inline {
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s;
    overflow: hidden;
  }
  .video-js .vjs-menu-button-inline:before {
    width: 2.222222222em;
  }
  .video-js .vjs-menu-button-inline:hover,
  .video-js .vjs-menu-button-inline:focus,
  .video-js .vjs-menu-button-inline.vjs-slider-active,
  .video-js.vjs-no-flex .vjs-menu-button-inline {
    width: 12em;
  }
  .video-js .vjs-menu-button-inline.vjs-slider-active {
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
  }
  .vjs-menu-button-inline .vjs-menu {
    opacity: 0;
    height: 100%;
    width: auto;
    position: absolute;
    left: 4em;
    top: 0;
    padding: 0;
    margin: 0;
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    transition: all 0.4s;
  }
  .vjs-menu-button-inline:hover .vjs-menu,
  .vjs-menu-button-inline:focus .vjs-menu,
  .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
    display: block;
    opacity: 1;
  }
  .vjs-no-flex .vjs-menu-button-inline .vjs-menu {
    display: block;
    opacity: 1;
    position: relative;
    width: auto;
  }
  .vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu,
  .vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,
  .vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu {
    width: auto;
  }
  .vjs-menu-button-inline .vjs-menu-content {
    width: auto;
    height: 100%;
    margin: 0;
    overflow: hidden;
  }
  .video-js .vjs-control-bar {
    display: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: #2b333f;
    background-color: rgba(43, 51, 63, 0.7);
  }
  .vjs-has-started .vjs-control-bar {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: flex;
    visibility: visible;
    opacity: 1;
    -webkit-transition:
      visibility 0.1s,
      opacity 0.1s;
    -moz-transition:
      visibility 0.1s,
      opacity 0.1s;
    transition:
      visibility 0.1s,
      opacity 0.1s;
  }
  .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
    visibility: visible;
    opacity: 0;
    -webkit-transition:
      visibility 1s,
      opacity 1s;
    -moz-transition:
      visibility 1s,
      opacity 1s;
    transition:
      visibility 1s,
      opacity 1s;
  }
  .vjs-controls-disabled .vjs-control-bar,
  .vjs-using-native-controls .vjs-control-bar,
  .vjs-error .vjs-control-bar {
    display: none !important;
  }
  .vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar {
    opacity: 1;
    visibility: visible;
  }
  .vjs-has-started.vjs-no-flex .vjs-control-bar {
    display: table;
  }
  .video-js .vjs-control {
    outline: none;
    position: relative;
    text-align: center;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 4em;
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .video-js .vjs-control:before {
    font-size: 1.8em;
    line-height: 1.67;
  }
  .video-js .vjs-control:focus:before,
  .video-js .vjs-control:hover:before,
  .video-js .vjs-control:focus {
    text-shadow: 0em 0em 1em #fff;
  }
  .video-js .vjs-control-text {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .vjs-no-flex .vjs-control {
    display: table-cell;
    vertical-align: middle;
  }
  .video-js .vjs-custom-control-spacer {
    display: none;
  }
  .video-js .vjs-progress-control {
    -webkit-box-flex: auto;
    -moz-box-flex: auto;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    -moz-box-align: center;
    align-items: center;
    min-width: 4em;
  }
  .vjs-live .vjs-progress-control {
    display: none;
  }
  .video-js .vjs-progress-holder {
    -webkit-box-flex: auto;
    -moz-box-flex: auto;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    transition: all 0.2s;
    height: 0.3em;
  }
  .video-js .vjs-progress-control:hover .vjs-progress-holder {
    font-size: 1.6666666667em;
  }
  .video-js .vjs-progress-control:hover .vjs-time-tooltip,
  .video-js .vjs-progress-control:hover .vjs-mouse-display:after,
  .video-js .vjs-progress-control:hover .vjs-play-progress:after {
    font-family: Arial, Helvetica, sans-serif;
    visibility: visible;
    font-size: 0.6em;
  }
  .video-js .vjs-progress-holder .vjs-play-progress,
  .video-js .vjs-progress-holder .vjs-load-progress,
  .video-js .vjs-progress-holder .vjs-tooltip-progress-bar,
  .video-js .vjs-progress-holder .vjs-load-progress div {
    position: absolute;
    display: block;
    height: 100%;
    margin: 0;
    padding: 0;
    width: 0;
    left: 0;
    top: 0;
  }
  .video-js .vjs-mouse-display:before {
    display: none;
  }
  .video-js .vjs-play-progress {
    background-color: #fff;
  }
  .video-js .vjs-play-progress:before {
    position: absolute;
    top: -0.3333333333em;
    right: -0.5em;
    font-size: 0.9em;
  }
  .video-js .vjs-time-tooltip,
  .video-js .vjs-mouse-display:after,
  .video-js .vjs-play-progress:after {
    visibility: hidden;
    pointer-events: none;
    position: absolute;
    top: -3.4em;
    right: -1.9em;
    font-size: 0.9em;
    color: #000;
    content: attr(data-current-time);
    padding: 6px 8px 8px 8px;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0.3em;
  }
  .video-js .vjs-time-tooltip,
  .video-js .vjs-play-progress:before,
  .video-js .vjs-play-progress:after {
    z-index: 1;
  }
  .video-js .vjs-progress-control .vjs-keep-tooltips-inside:after {
    display: none;
  }
  .video-js .vjs-load-progress {
    background: #bfc7d3;
    background: rgba(115, 133, 159, 0.5);
  }
  .video-js .vjs-load-progress div {
    background: #fff;
    background: rgba(115, 133, 159, 0.75);
  }
  .video-js.vjs-no-flex .vjs-progress-control {
    width: auto;
  }
  .video-js .vjs-time-tooltip {
    display: inline-block;
    height: 2.4em;
    position: relative;
    float: right;
    right: -1.9em;
  }
  .vjs-tooltip-progress-bar {
    visibility: hidden;
  }
  .video-js .vjs-progress-control .vjs-mouse-display {
    display: none;
    position: absolute;
    width: 1px;
    height: 100%;
    background-color: #000;
    z-index: 1;
  }
  .vjs-no-flex .vjs-progress-control .vjs-mouse-display {
    z-index: 0;
  }
  .video-js .vjs-progress-control:hover .vjs-mouse-display {
    display: block;
  }
  .video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display,
  .video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display:after {
    visibility: hidden;
    opacity: 0;
    -webkit-transition:
      visibility 1s,
      opacity 1s;
    -moz-transition:
      visibility 1s,
      opacity 1s;
    transition:
      visibility 1s,
      opacity 1s;
  }
  .video-js.vjs-user-inactive.vjs-no-flex
    .vjs-progress-control
    .vjs-mouse-display,
  .video-js.vjs-user-inactive.vjs-no-flex
    .vjs-progress-control
    .vjs-mouse-display:after {
    display: none;
  }
  .vjs-mouse-display .vjs-time-tooltip,
  .video-js .vjs-progress-control .vjs-mouse-display:after {
    color: #fff;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .video-js .vjs-slider {
    outline: 0;
    position: relative;
    cursor: pointer;
    padding: 0;
    margin: 0 0.45em 0 0.45em;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #73859f;
    background-color: rgba(115, 133, 159, 0.5);
  }
  .video-js .vjs-slider:focus {
    text-shadow: 0em 0em 1em #fff;
    -webkit-box-shadow: 0 0 1em #fff;
    box-shadow: 0 0 1em #fff;
  }
  .video-js .vjs-mute-control,
  .video-js .vjs-volume-menu-button {
    cursor: pointer;
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .video-js .vjs-volume-control {
    width: 5em;
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    -moz-box-align: center;
    align-items: center;
  }
  .video-js .vjs-volume-bar {
    margin: 1.35em 0.45em;
  }
  .vjs-volume-bar.vjs-slider-horizontal {
    width: 5em;
    height: 0.3em;
  }
  .vjs-volume-bar.vjs-slider-vertical {
    width: 0.3em;
    height: 5em;
    margin: 1.35em auto;
  }
  .video-js .vjs-volume-level {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
  }
  .video-js .vjs-volume-level:before {
    position: absolute;
    font-size: 0.9em;
  }
  .vjs-slider-vertical .vjs-volume-level {
    width: 0.3em;
  }
  .vjs-slider-vertical .vjs-volume-level:before {
    top: -0.5em;
    left: -0.3em;
  }
  .vjs-slider-horizontal .vjs-volume-level {
    height: 0.3em;
  }
  .vjs-slider-horizontal .vjs-volume-level:before {
    top: -0.3em;
    right: -0.5em;
  }
  .vjs-volume-bar.vjs-slider-vertical .vjs-volume-level {
    height: 100%;
  }
  .vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level {
    width: 100%;
  }
  .vjs-menu-button-popup.vjs-volume-menu-button .vjs-menu {
    display: block;
    width: 0;
    height: 0;
    border-top-color: transparent;
  }
  .vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {
    left: 0.5em;
    height: 8em;
  }
  .vjs-menu-button-popup.vjs-volume-menu-button-horizontal .vjs-menu {
    left: -2em;
  }
  .vjs-menu-button-popup.vjs-volume-menu-button .vjs-menu-content {
    height: 0;
    width: 0;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .vjs-volume-menu-button-vertical:hover .vjs-menu-content,
  .vjs-volume-menu-button-vertical:focus .vjs-menu-content,
  .vjs-volume-menu-button-vertical.vjs-slider-active .vjs-menu-content,
  .vjs-volume-menu-button-vertical .vjs-lock-showing .vjs-menu-content {
    height: 8em;
    width: 2.9em;
  }
  .vjs-volume-menu-button-horizontal:hover .vjs-menu-content,
  .vjs-volume-menu-button-horizontal:focus .vjs-menu-content,
  .vjs-volume-menu-button-horizontal .vjs-slider-active .vjs-menu-content,
  .vjs-volume-menu-button-horizontal .vjs-lock-showing .vjs-menu-content {
    height: 2.9em;
    width: 8em;
  }
  .vjs-volume-menu-button.vjs-menu-button-inline .vjs-menu-content {
    background-color: transparent !important;
  }
  .vjs-poster {
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    background-color: #000;
    cursor: pointer;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
  }
  .vjs-poster img {
    display: block;
    vertical-align: middle;
    margin: 0 auto;
    max-height: 100%;
    padding: 0;
    width: 100%;
  }
  .vjs-has-started .vjs-poster {
    display: none;
  }
  .vjs-audio.vjs-has-started .vjs-poster {
    display: block;
  }
  .vjs-using-native-controls .vjs-poster {
    display: none;
  }
  .video-js .vjs-live-control {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: -moz-box;
    display: flex;
    -webkit-box-align: flex-start;
    -webkit-align-items: flex-start;
    -ms-flex-align: flex-start;
    -moz-box-align: start;
    align-items: flex-start;
    -webkit-box-flex: auto;
    -moz-box-flex: auto;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
    font-size: 1em;
    line-height: 3em;
  }
  .vjs-no-flex .vjs-live-control {
    display: table-cell;
    width: auto;
    text-align: left;
  }
  .video-js .vjs-time-control {
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
    font-size: 1em;
    line-height: 3em;
    min-width: 2em;
    width: auto;
    padding-left: 1em;
    padding-right: 1em;
  }
  .vjs-live .vjs-time-control {
    display: none;
  }
  .video-js .vjs-current-time,
  .vjs-no-flex .vjs-current-time {
    display: none;
  }
  .video-js .vjs-duration,
  .vjs-no-flex .vjs-duration {
    display: none;
  }
  .vjs-time-divider {
    display: none;
    line-height: 3em;
  }
  .vjs-live .vjs-time-divider {
    display: none;
  }
  .video-js .vjs-play-control {
    cursor: pointer;
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .vjs-text-track-display {
    position: absolute;
    bottom: 3em;
    left: 0;
    right: 0;
    top: 0;
    pointer-events: none;
  }
  .video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display {
    bottom: 1em;
  }
  .video-js .vjs-text-track {
    font-size: 1.4em;
    text-align: center;
    margin-bottom: 0.1em;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .vjs-subtitles {
    color: #fff;
  }
  .vjs-captions {
    color: #fc6;
  }
  .vjs-tt-cue {
    display: block;
  }
  video::-webkit-media-text-track-display {
    -moz-transform: translateY(-3em);
    -webkit-transform: translateY(-3em);
    transform: translateY(-3em);
  }
  .video-js.vjs-user-inactive.vjs-playing
    video::-webkit-media-text-track-display {
    -moz-transform: translateY(-1.5em);
    -webkit-transform: translateY(-1.5em);
    transform: translateY(-1.5em);
  }
  .video-js .vjs-fullscreen-control {
    cursor: pointer;
    -webkit-box-flex: none;
    -moz-box-flex: none;
    -webkit-flex: none;
    -ms-flex: none;
    flex: none;
  }
  .vjs-playback-rate .vjs-playback-rate-value {
    font-size: 1.5em;
    line-height: 2;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .vjs-playback-rate .vjs-menu {
    width: 4em;
    left: 0em;
  }
  .vjs-error .vjs-error-display .vjs-modal-dialog-content {
    font-size: 1.4em;
    text-align: center;
  }
  .vjs-error .vjs-error-display:before {
    color: #fff;
    content: "X";
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4em;
    left: 0;
    line-height: 1;
    margin-top: -0.5em;
    position: absolute;
    text-shadow: 0.05em 0.05em 0.1em #000;
    text-align: center;
    top: 50%;
    vertical-align: middle;
    width: 100%;
  }
  .vjs-loading-spinner {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -25px 0 0 -25px;
    opacity: 0.85;
    text-align: left;
    border: 6px solid rgba(43, 51, 63, 0.7);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background-clip: padding-box;
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }
  .vjs-seeking .vjs-loading-spinner,
  .vjs-waiting .vjs-loading-spinner {
    display: block;
  }
  .vjs-loading-spinner:before,
  .vjs-loading-spinner:after {
    content: "";
    position: absolute;
    margin: -6px;
    -webkit-box-sizing: inherit;
    -moz-box-sizing: inherit;
    box-sizing: inherit;
    width: inherit;
    height: inherit;
    border-radius: inherit;
    opacity: 1;
    border: inherit;
    border-color: transparent;
    border-top-color: #fff;
  }
  .vjs-seeking .vjs-loading-spinner:before,
  .vjs-seeking .vjs-loading-spinner:after,
  .vjs-waiting .vjs-loading-spinner:before,
  .vjs-waiting .vjs-loading-spinner:after {
    -webkit-animation:
      vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
      vjs-spinner-fade 1.1s linear infinite;
    -moz-animation:
      vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
      vjs-spinner-fade 1.1s linear infinite;
    animation:
      vjs-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite,
      vjs-spinner-fade 1.1s linear infinite;
  }
  .vjs-seeking .vjs-loading-spinner:before,
  .vjs-waiting .vjs-loading-spinner:before {
    border-top-color: #fff;
  }
  .vjs-seeking .vjs-loading-spinner:after,
  .vjs-waiting .vjs-loading-spinner:after {
    border-top-color: #fff;
    -webkit-animation-delay: 0.44s;
    -moz-animation-delay: 0.44s;
    animation-delay: 0.44s;
  }
  @-moz-keyframes vjs-spinner-spin {
    100% {
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes vjs-spinner-spin {
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes vjs-spinner-spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @-moz-keyframes vjs-spinner-fade {
    0% {
      border-top-color: #73859f;
    }
    20% {
      border-top-color: #73859f;
    }
    35% {
      border-top-color: #fff;
    }
    60% {
      border-top-color: #73859f;
    }
    100% {
      border-top-color: #73859f;
    }
  }
  @keyframes vjs-spinner-fade {
    0% {
      border-top-color: #73859f;
    }
    20% {
      border-top-color: #73859f;
    }
    35% {
      border-top-color: #fff;
    }
    60% {
      border-top-color: #73859f;
    }
    100% {
      border-top-color: #73859f;
    }
  }
  @-webkit-keyframes vjs-spinner-fade {
    0% {
      border-top-color: #73859f;
    }
    20% {
      border-top-color: #73859f;
    }
    35% {
      border-top-color: #fff;
    }
    60% {
      border-top-color: #73859f;
    }
    100% {
      border-top-color: #73859f;
    }
  }
  .vjs-chapters-button .vjs-menu ul {
    width: 24em;
  }
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-custom-control-spacer {
    -webkit-box-flex: auto;
    -moz-box-flex: auto;
    -webkit-flex: auto;
    -ms-flex: auto;
    flex: auto;
  }
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen).vjs-no-flex
    .vjs-custom-control-spacer {
    width: auto;
  }
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-current-time,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-time-divider,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-duration,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-remaining-time,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-playback-rate,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-progress-control,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-mute-control,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-control,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-volume-menu-button,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-chapters-button,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-descriptions-button,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-captions-button,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-subtitles-button,
  .video-js.vjs-layout-tiny:not(.vjs-fullscreen) .vjs-audio-button {
    display: none;
  }
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-current-time,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-time-divider,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-duration,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-remaining-time,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-playback-rate,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-mute-control,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-control,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-volume-menu-button,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-chapters-button,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-descriptions-button,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-captions-button,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-subtitles-button,
  .video-js.vjs-layout-x-small:not(.vjs-fullscreen) .vjs-audio-button {
    display: none;
  }
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-current-time,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-time-divider,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-duration,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-remaining-time,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-playback-rate,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-mute-control,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-volume-control,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-chapters-button,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-descriptions-button,
  .video-js.vjs-layout-small:not(.vjs-fullscreen) .vjs-captions-button,
  .video-js.vjs-layout-small:not(.vjs-fullscreen)
    .vjs-subtitles-button
    .vjs-audio-button {
    display: none;
  }
  .vjs-caption-settings {
    position: relative;
    top: 1em;
    background-color: #2b333f;
    background-color: rgba(43, 51, 63, 0.75);
    color: #fff;
    margin: 0 auto;
    padding: 0.5em;
    height: 16em;
    font-size: 12px;
    width: 40em;
  }
  .vjs-caption-settings .vjs-tracksettings {
    top: 0;
    bottom: 1em;
    left: 0;
    right: 0;
    position: absolute;
    overflow: auto;
  }
  .vjs-caption-settings .vjs-tracksettings-colors,
  .vjs-caption-settings .vjs-tracksettings-font {
    float: left;
  }
  .vjs-caption-settings .vjs-tracksettings-colors:after,
  .vjs-caption-settings .vjs-tracksettings-font:after,
  .vjs-caption-settings .vjs-tracksettings-controls:after {
    clear: both;
  }
  .vjs-caption-settings .vjs-tracksettings-controls {
    position: absolute;
    bottom: 1em;
    right: 1em;
  }
  .vjs-caption-settings .vjs-tracksetting {
    margin: 5px;
    padding: 3px;
    min-height: 40px;
    border: none;
  }
  .vjs-caption-settings .vjs-tracksetting label,
  .vjs-caption-settings .vjs-tracksetting legend {
    display: block;
    width: 100px;
    margin-bottom: 5px;
  }
  .vjs-caption-settings .vjs-tracksetting span {
    display: inline;
    margin-left: 5px;
    vertical-align: top;
    float: right;
  }
  .vjs-caption-settings .vjs-tracksetting > div {
    margin-bottom: 5px;
    min-height: 20px;
  }
  .vjs-caption-settings .vjs-tracksetting > div:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    min-height: 0;
  }
  .vjs-caption-settings label > input {
    margin-right: 10px;
  }
  .vjs-caption-settings fieldset {
    margin-top: 1em;
    margin-left: 0.5em;
  }
  .vjs-caption-settings fieldset .vjs-label {
    position: absolute;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;
  }
  .vjs-caption-settings input[type="button"] {
    width: 40px;
    height: 40px;
  }
  .video-js .vjs-modal-dialog {
    background: rgba(0, 0, 0, 0.8);
    background: -webkit-linear-gradient(
      -90deg,
      rgba(0, 0, 0, 0.8),
      rgba(255, 255, 255, 0)
    );
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(rgba(0, 0, 0, 0.8)),
      to(rgba(255, 255, 255, 0))
    );
    background: -webkit-linear-gradient(
      top,
      rgba(0, 0, 0, 0.8),
      rgba(255, 255, 255, 0)
    );
    background: -moz-linear-gradient(
      top,
      rgba(0, 0, 0, 0.8),
      rgba(255, 255, 255, 0)
    );
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.8),
      rgba(255, 255, 255, 0)
    );
  }
  .vjs-modal-dialog .vjs-modal-dialog-content {
    font-size: 1.2em;
    line-height: 1.5;
    padding: 20px 24px;
    z-index: 1;
  }
  @media print {
    .video-js > *:not(.vjs-tech):not(.vjs-poster) {
      visibility: hidden;
    }
  }
  .video-js .theo-player-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
  }
  .video-js .vjs-tech {
    position: absolute;
    z-index: 0;
  }
  .theo-primary-color,
  .theo-upnext-panel .theo-upnext-panel-content .theo-upnext-panel-autoplay,
  .theoplayer-skin .theo-settings-control-menu-item-hd-label,
  .theoplayer-skin .theo-settings-control-menu-item-value,
  .theoplayer-skin .vjs-volume-level,
  .theoplayer-skin .vjs-play-progress,
  .theoplayer-skin .vjs-slider-bar,
  .theoplayer-skin .vjs-big-play-button {
    color: #ffc50f;
  }
  .theo-primary-background,
  .theo-social .theo-social-container .theo-social-label,
  .theoplayer-skin .theo-menu-header,
  .theoplayer-skin .theo-settings-control-label-hd {
    color: #000;
    background-color: #ffc50f;
  }
  .theo-primary-border,
  .theo-related-grid
    .theo-related-grid-tile:hover
    .theo-related-grid-tile-content
    .theo-related-grid-tile-title {
    border-color: #ffc50f;
  }
  .theo-secondary-color,
  .theoplayer-skin .vjs-loading-spinner,
  .theoplayer-skin .vjs-time-tooltip,
  .theoplayer-skin .vjs-control-bar,
  .theoplayer-skin {
    color: #fff;
  }
  .theo-secondary-background,
  .theoplayer-skin .theo-overlay-panel .theo-close-button {
    color: #000;
    background-color: #fff;
  }
  .theo-tertiary-color,
  .theoplayer-skin .theo-control-bar-shadow {
    color: #000;
  }
  .theo-tertiary-background,
  .theo-social
    .theo-social-container
    .theo-social-text-container
    .theo-social-content-container,
  .theo-related-grid
    .theo-related-grid-tile:hover
    .theo-related-grid-tile-content
    .theo-related-grid-tile-title,
  .theoplayer-skin
    .theo-menu.theo-menu-animatable
    .theo-menu-animation-container {
    color: #fff;
    background-color: rgba(28, 28, 28, 0.9);
  }
  .theoplayer-skin,
  .theoplayer-skin * {
    outline: none;
  }
  .theoplayer-skin {
    font-size: 12px;
  }
  .theoplayer-skin .vjs-control-bar {
    background: none;
    z-index: 0;
  }
  .theoplayer-skin .theo-control-bar-shadow {
    display: block;
    position: absolute;
    z-index: -1;
    left: 0;
    right: 0;
    bottom: 0;
    height: 125%;
    pointer-events: none;
    background: currentColor;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(currentColor)
    );
    background: -webkit-linear-gradient(top, transparent, currentColor);
    background: -moz-linear-gradient(top, transparent, currentColor);
    background: linear-gradient(to bottom, transparent, currentColor);
  }
  .theoplayer-skin .vjs-big-play-button {
    font-size: 3em;
    border-radius: 100%;
    background: none;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
    width: 20%;
    height: 0;
    padding-bottom: 20%;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .theoplayer-skin .vjs-big-play-button:before {
    display: none;
  }
  .theoplayer-skin .vjs-big-play-button:after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    border-radius: 100%;
    -webkit-box-shadow: 0 0 2em currentColor;
    box-shadow: 0 0 2em currentColor;
    opacity: 0;
    -webkit-transition: all 0.1s ease-in-out;
    -moz-transition: all 0.1s ease-in-out;
    transition: all 0.1s ease-in-out;
  }
  .theoplayer-skin .vjs-big-play-button svg {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }
  .theoplayer-skin .vjs-big-play-button,
  .theoplayer-skin:hover .vjs-big-play-button,
  .theoplayer-skin .vjs-big-play-button:focus {
    border: none;
  }
  .theoplayer-skin:hover .vjs-big-play-button,
  .theoplayer-skin .vjs-big-play-button:focus {
    background: rgba(0, 0, 0, 0.4);
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }
  .theoplayer-skin:hover .vjs-big-play-button:after,
  .theoplayer-skin .vjs-big-play-button:focus:after {
    opacity: 0.6;
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    transition-duration: 0.2s;
  }
  .theoplayer-skin .theo-button-tooltip {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: 600;
    border-radius: 2px;
    background-color: #161719;
    display: block;
    position: absolute;
    bottom: 100%;
    padding: 0.5em 1em;
    text-transform: none;
    white-space: nowrap;
    text-align: center;
    z-index: 1;
    opacity: 0;
    -webkit-transition: opacity 0.2s;
    -moz-transition: opacity 0.2s;
    transition: opacity 0.2s;
    text-shadow: none;
  }
  .theoplayer-skin .vjs-button:hover .theo-button-tooltip {
    opacity: 1;
  }
  .theoplayer-skin .vjs-volume-level,
  .theoplayer-skin .vjs-play-progress,
  .theoplayer-skin .vjs-slider-bar {
    background: currentColor;
  }
  .theoplayer-skin .vjs-slider {
    background: rgba(255, 255, 255, 0.2);
  }
  .theoplayer-skin .vjs-load-progress {
    background: rgba(255, 255, 255, 0.4);
  }
  .theoplayer-skin .vjs-load-progress div {
    background: rgba(255, 255, 255, 0.6);
  }
  .theoplayer-skin .vjs-slider-vertical .vjs-volume-level:before {
    top: -0.5em;
    left: -0.25em;
  }
  .theoplayer-skin .vjs-slider-horizontal .vjs-volume-level:before {
    top: -0.25em;
    right: -0.5em;
  }
  .theoplayer-skin .vjs-time-control {
    display: none;
    padding: 0 0.25em;
  }
  .theoplayer-skin .vjs-current-time,
  .theoplayer-skin .vjs-time-divider,
  .theoplayer-skin .vjs-duration {
    display: block;
  }
  .theoplayer-skin .vjs-time-divider {
    min-width: 0;
  }
  .theoplayer-skin.vjs-live .vjs-time-control {
    display: none;
  }
  .theoplayer-skin.vjs-live .vjs-remaining-time {
    display: block;
  }
  .theoplayer-skin .theo-live-control {
    cursor: pointer;
    min-width: 4em;
    width: auto;
    text-transform: uppercase;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
  }
  .theoplayer-skin .theo-live-control-indicator {
    color: #888;
  }
  .theoplayer-skin.theo-at-live .theo-live-control-indicator {
    color: red;
  }
  .theoplayer-skin .theo-live-control-text {
    margin-left: 0.5em;
  }
  .theoplayer-skin .vjs-progress-control {
    margin: 0 0.45em;
  }
  .theoplayer-skin .vjs-progress-holder {
    margin: 0;
  }
  .theoplayer-skin.vjs-fullscreen {
    font-size: 18px;
  }
  .theoplayer-skin.theo-dvr .vjs-progress-control {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
  }
  .theoplayer-skin .vjs-progress-control .vjs-progress-holder {
    height: 0.3em;
  }
  .theoplayer-skin .vjs-progress-control:hover .vjs-progress-holder {
    font-size: inherit;
    height: 0.5em;
  }
  .theoplayer-skin .vjs-control-bar {
    height: 3em;
    padding: 0 0.5em;
  }
  .theoplayer-skin .vjs-control-bar .vjs-control.vjs-button {
    width: 3em;
  }
  @supports (padding: max(0px)) {
    .theoplayer-skin.vjs-fullscreen .vjs-control-bar {
      height: -webkit-calc(3em + env(safe-area-inset-bottom));
      height: -moz-calc(3em + env(safe-area-inset-bottom));
      height: calc(3em + env(safe-area-inset-bottom));
      padding-left: max(0.5em, env(safe-area-inset-left));
      padding-right: max(0.5em, env(safe-area-inset-right));
    }
    .theoplayer-skin.vjs-fullscreen .vjs-progress-control {
      height: -webkit-calc(3em + env(safe-area-inset-bottom));
      height: -moz-calc(3em + env(safe-area-inset-bottom));
      height: calc(3em + env(safe-area-inset-bottom));
      padding-left: max(0.5em, env(safe-area-inset-left));
      padding-right: max(0.5em, env(safe-area-inset-right));
    }
    .theoplayer-skin.vjs-fullscreen .vjs-duration {
      padding-right: max(0.5em, env(safe-area-inset-right));
    }
    .theoplayer-skin.vjs-fullscreen .vjs-button .theo-button-icon-blur {
      bottom: 2em;
    }
    .theoplayer-skin.vjs-fullscreen .theo-cast-button .theo-cast-svg-container {
      position: absolute;
      top: 0;
    }
    .theoplayer-skin.vjs-fullscreen .theoplayer-ima {
      margin-left: env(safe-area-inset-left);
      margin-right: env(safe-area-inset-right);
    }
  }
  .theoplayer-skin .theo-controlbar-button {
    cursor: pointer;
    position: relative;
    text-transform: uppercase;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 0;
    -webkit-flex: none;
    -moz-box-flex: 0;
    -ms-flex: none;
    flex: none;
  }
  .theoplayer-skin .theo-settings-control-label-hd {
    display: none;
    font-weight: bold;
    font-size: 0.7em;
    padding: 0.1em 0.15em 0.05em 0.15em;
    font-family: Arial, Helvetica, sans-serif;
    position: absolute;
    right: 0.3em;
    top: 0.95em;
    -webkit-box-shadow: #000 0px 0px 1px;
    box-shadow: #000 0px 0px 1px;
    border-radius: 0.125em;
  }
  .theoplayer-skin.theo-hd .theo-settings-control-label-hd {
    display: block;
  }
  .theoplayer-skin .theo-no-transition {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    transition: none !important;
  }
  .theoplayer-skin .vjs-progress-control .vjs-time-tooltip,
  .theoplayer-skin .vjs-progress-control .vjs-mouse-display:after,
  .theoplayer-skin .vjs-progress-control .vjs-play-progress:after {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 1em;
  }
  .theoplayer-skin .vjs-progress-control:hover .vjs-time-tooltip,
  .theoplayer-skin .vjs-progress-control:hover .vjs-mouse-display:after,
  .theoplayer-skin .vjs-progress-control:hover .vjs-play-progress:after {
    font-size: inherit;
  }
  .theoplayer-skin .vjs-play-progress:before {
    font-size: 1.5em;
    top: 50%;
    right: 0;
    -webkit-transform: translate(50%, -50%) scale(0);
    -moz-transform: translate(50%, -50%) scale(0);
    transform: translate(50%, -50%) scale(0);
    -webkit-transition: -webkit-transform 0.2s;
    transition: -webkit-transform 0.2s;
    -moz-transition:
      transform 0.2s,
      -moz-transform 0.2s;
    transition: transform 0.2s;
    transition:
      transform 0.2s,
      -webkit-transform 0.2s,
      -moz-transform 0.2s;
    pointer-events: none;
  }
  .theoplayer-skin .vjs-progress-control:hover .vjs-play-progress:before {
    -webkit-transform: translate(50%, -50%) scale(1);
    -moz-transform: translate(50%, -50%) scale(1);
    transform: translate(50%, -50%) scale(1);
  }
  .theoplayer-skin .vjs-time-tooltip {
    height: auto;
    top: 100%;
    -webkit-transform: translateY(-100%) translateY(-1em);
    -moz-transform: translateY(-100%) translateY(-1em);
    transform: translateY(-100%) translateY(-1em);
  }
  .theoplayer-skin .vjs-progress-control .vjs-mouse-display {
    z-index: 2;
    pointer-events: none;
  }
  .theoplayer-skin .vjs-tooltip-progress-bar .vjs-time-tooltip,
  .theoplayer-skin .vjs-play-progress:after {
    display: none;
  }
  .theoplayer-skin .theo-time-tooltip-thumbnail {
    display: none;
    background: #000;
  }
  .theoplayer-skin .theo-time-tooltip-has-thumbnail .vjs-time-tooltip {
    padding: 0;
    border-radius: 0;
    -webkit-box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.8);
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.8);
  }
  .theoplayer-skin
    .theo-time-tooltip-has-thumbnail
    .theo-time-tooltip-thumbnail {
    display: block;
    width: 10em;
  }
  .theoplayer-skin .theo-time-tooltip-has-thumbnail .theo-time-tooltip-text {
    position: absolute;
    bottom: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    transform: translateX(-50%);
    padding: 3px 4px;
    border-radius: 0.3em;
    color: #fff;
    background-color: #000;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .theoplayer-skin .vjs-play-control {
    -webkit-box-ordinal-group: -99;
    -webkit-order: -100;
    -moz-box-ordinal-group: -99;
    -ms-flex-order: -100;
    order: -100;
  }
  .theoplayer-skin .vjs-volume-menu-button {
    -webkit-box-ordinal-group: -89;
    -webkit-order: -90;
    -moz-box-ordinal-group: -89;
    -ms-flex-order: -90;
    order: -90;
  }
  .theoplayer-skin .theo-live-control {
    -webkit-box-ordinal-group: -79;
    -webkit-order: -80;
    -moz-box-ordinal-group: -79;
    -ms-flex-order: -80;
    order: -80;
  }
  .theoplayer-skin .vjs-mute-control {
    -webkit-box-ordinal-group: -98;
    -webkit-order: -99;
    -moz-box-ordinal-group: -98;
    -ms-flex-order: -99;
    order: -99;
    width: 3em;
  }
  .theoplayer-skin .vjs-volume-control {
    -webkit-box-ordinal-group: -97;
    -webkit-order: -98;
    -moz-box-ordinal-group: -97;
    -ms-flex-order: -98;
    order: -98;
    width: auto;
    margin: 0;
  }
  .theoplayer-skin .vjs-volume-control .vjs-volume-bar {
    margin-right: 1em;
    opacity: 1;
    width: 5em;
    -webkit-transition:
      margin 0.4s ease-in-out,
      opacity 0.4s ease-in-out,
      width 0.4s ease-in-out;
    -moz-transition:
      margin 0.4s ease-in-out,
      opacity 0.4s ease-in-out,
      width 0.4s ease-in-out;
    transition:
      margin 0.4s ease-in-out,
      opacity 0.4s ease-in-out,
      width 0.4s ease-in-out;
  }
  .theoplayer-skin .vjs-volume-control .vjs-volume-bar:focus {
    -webkit-transition:
      margin 0.1s ease-in-out,
      opacity 0.1s ease-in-out,
      width 0.1s ease-in-out;
    -moz-transition:
      margin 0.1s ease-in-out,
      opacity 0.1s ease-in-out,
      width 0.1s ease-in-out;
    transition:
      margin 0.1s ease-in-out,
      opacity 0.1s ease-in-out,
      width 0.1s ease-in-out;
  }
  .theoplayer-skin
    .vjs-mute-control:not(:hover)
    + .vjs-volume-control:not(:hover)
    .vjs-volume-bar:not(:hover):not(:focus) {
    margin-right: 0;
    opacity: 0;
    width: 0;
  }
  .theoplayer-skin .theo-settings-control-button {
    -webkit-box-ordinal-group: 96;
    -webkit-order: 95;
    -moz-box-ordinal-group: 96;
    -ms-flex-order: 95;
    order: 95;
  }
  .theoplayer-skin .theo-audio-track-control-button {
    -webkit-box-ordinal-group: 95;
    -webkit-order: 94;
    -moz-box-ordinal-group: 95;
    -ms-flex-order: 94;
    order: 94;
  }
  .theoplayer-skin .theo-text-track-control-button {
    -webkit-box-ordinal-group: 94;
    -webkit-order: 93;
    -moz-box-ordinal-group: 94;
    -ms-flex-order: 93;
    order: 93;
  }
  .theoplayer-skin .vjs-fullscreen-control {
    -webkit-box-ordinal-group: 101;
    -webkit-order: 100;
    -moz-box-ordinal-group: 101;
    -ms-flex-order: 100;
    order: 100;
  }
  .theoplayer-skin:not(.theo-seekbar-inside-controls) .theo-control-bar-shadow {
    height: 150%;
  }
  .theoplayer-skin:not(.theo-seekbar-inside-controls) .vjs-progress-control {
    position: absolute;
    margin: 0;
    left: 1em;
    right: 1em;
    bottom: 100%;
    width: auto;
    height: 0.5em;
    -webkit-box-align: end;
    -webkit-align-items: flex-end;
    -moz-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }
  .theoplayer-skin:not(.theo-seekbar-inside-controls)
    .vjs-custom-control-spacer {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: auto;
    -moz-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
  }
  .theoplayer-skin:not(.theo-seekbar-inside-controls) .theo-button-tooltip {
    margin-bottom: 1em;
  }
  .theoplayer-skin.vjs-live.theo-at-live .vjs-remaining-time {
    visibility: hidden;
  }
  .theoplayer-skin.vjs-error .vjs-error-display:before,
  .theoplayer-skin.vjs-error .vjs-error-display:after {
    display: none;
  }
  .theoplayer-skin.vjs-error .vjs-modal-dialog-content {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    font-size: 2em;
  }
  .theoplayer-skin.vjs-error .vjs-modal-dialog {
    background: url("data:image/png;base64,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") !important;
    -webkit-animation: theo-noise-animation 0.2s linear infinite;
    -moz-animation: theo-noise-animation 0.2s linear infinite;
    animation: theo-noise-animation 0.2s linear infinite;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: inset 0 0 10em rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 10em rgba(0, 0, 0, 0.3);
    pointer-events: none;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
  }
  @-webkit-keyframes theo-noise-animation {
    0% {
      background-position: 0 0;
    }
    0.1% {
      background-position: -7px -7px;
    }
    25% {
      background-position: -7px -7px;
    }
    25.1% {
      background-position: 7px -1px;
    }
    50% {
      background-position: 7px -7px;
    }
    50.1% {
      background-position: 5px 5px;
    }
    75% {
      background-position: 3px 2px;
    }
    75.1% {
      background-position: -3px 4px;
    }
    100% {
      background-position: -3px 3px;
    }
  }
  @-moz-keyframes theo-noise-animation {
    0% {
      background-position: 0 0;
    }
    0.1% {
      background-position: -7px -7px;
    }
    25% {
      background-position: -7px -7px;
    }
    25.1% {
      background-position: 7px -1px;
    }
    50% {
      background-position: 7px -7px;
    }
    50.1% {
      background-position: 5px 5px;
    }
    75% {
      background-position: 3px 2px;
    }
    75.1% {
      background-position: -3px 4px;
    }
    100% {
      background-position: -3px 3px;
    }
  }
  @keyframes theo-noise-animation {
    0% {
      background-position: 0 0;
    }
    0.1% {
      background-position: -7px -7px;
    }
    25% {
      background-position: -7px -7px;
    }
    25.1% {
      background-position: 7px -1px;
    }
    50% {
      background-position: 7px -7px;
    }
    50.1% {
      background-position: 5px 5px;
    }
    75% {
      background-position: 3px 2px;
    }
    75.1% {
      background-position: -3px 4px;
    }
    100% {
      background-position: -3px 3px;
    }
  }
  .theoplayer-skin.vjs-error.vjs-fullscreen .vjs-control-bar {
    display: -webkit-box !important;
    display: -webkit-flex !important;
    display: -moz-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .theoplayer-skin.vjs-error.vjs-fullscreen .vjs-control {
    display: block;
  }
  .theoplayer-skin.vjs-error.vjs-fullscreen .vjs-control,
  .theoplayer-skin.vjs-error.vjs-fullscreen .vjs-time-control {
    visibility: hidden;
  }
  .theoplayer-skin.vjs-error.vjs-fullscreen
    .vjs-control.vjs-fullscreen-control {
    visibility: visible;
  }
  .theoplayer-skin.vjs-user-inactive.vjs-fullscreen {
    cursor: inherit;
  }
  .theoplayer-skin.vjs-user-inactive.vjs-playing:not(.theo-menu-opened) {
    cursor: none;
  }
  .theoplayer-skin.vjs-user-inactive.vjs-playing .vjs-control-bar .vjs-control {
    pointer-events: none;
  }
  .theoplayer-skin .vjs-loading-spinner {
    border: none;
    border-radius: 0;
    opacity: 0.7;
    pointer-events: none;
    width: 50px;
    height: 50px;
    margin: -25px 0 0 -25px;
  }
  .theoplayer-skin .vjs-loading-spinner:before,
  .theoplayer-skin .vjs-loading-spinner:after {
    display: none;
  }
  .theoplayer-skin .theo-loading-spinner-rotator {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .theoplayer-skin .theo-loading-spinner-circle-left,
  .theoplayer-skin .theo-loading-spinner-circle-right {
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }
  .theoplayer-skin .theo-loading-spinner-circle-left {
    left: 0;
    right: 49%;
  }
  .theoplayer-skin .theo-loading-spinner-circle-right {
    left: 49%;
    right: 0;
  }
  .theoplayer-skin .theo-loading-spinner-circle-left:before,
  .theoplayer-skin .theo-loading-spinner-circle-right:before {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    width: 200%;
    height: 100%;
    border-radius: 50%;
    border: 5px solid currentColor;
    border-bottom-color: transparent;
  }
  .theoplayer-skin .theo-loading-spinner-circle-left:before {
    left: 0;
    right: -100%;
    border-right-color: transparent;
  }
  .theoplayer-skin .theo-loading-spinner-circle-right:before {
    left: -100%;
    right: 0;
    border-left-color: transparent;
  }
  .theoplayer-skin.vjs-seeking .vjs-loading-spinner,
  .theoplayer-skin.vjs-waiting .vjs-loading-spinner {
    -webkit-animation: theo-spinner-linspin 1568.23529647ms linear infinite;
    -moz-animation: theo-spinner-linspin 1568.23529647ms linear infinite;
    animation: theo-spinner-linspin 1568.23529647ms linear infinite;
  }
  .theoplayer-skin.vjs-seeking .theo-loading-spinner-rotator,
  .theoplayer-skin.vjs-waiting .theo-loading-spinner-rotator {
    -webkit-animation: theo-spinner-easespin 5332ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
    -moz-animation: theo-spinner-easespin 5332ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
    animation: theo-spinner-easespin 5332ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
  }
  .theoplayer-skin.vjs-seeking .theo-loading-spinner-circle-left:before,
  .theoplayer-skin.vjs-waiting .theo-loading-spinner-circle-left:before {
    -webkit-animation: theo-spinner-left-spin 1333ms
      cubic-bezier(0.4, 0, 0.2, 1) infinite both;
    -moz-animation: theo-spinner-left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
    animation: theo-spinner-left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
  }
  .theoplayer-skin.vjs-seeking .theo-loading-spinner-circle-right:before,
  .theoplayer-skin.vjs-waiting .theo-loading-spinner-circle-right:before {
    -webkit-animation: theo-spinner-right-spin 1333ms
      cubic-bezier(0.4, 0, 0.2, 1) infinite both;
    -moz-animation: theo-spinner-right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
    animation: theo-spinner-right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1)
      infinite both;
  }
  .theoplayer-skin.vjs-error .vjs-loading-spinner,
  .theoplayer-skin:not(.vjs-has-started) .vjs-loading-spinner {
    display: none;
  }
  @-webkit-keyframes theo-spinner-linspin {
    to {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-moz-keyframes theo-spinner-linspin {
    to {
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes theo-spinner-linspin {
    to {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes theo-spinner-easespin {
    12.5% {
      -webkit-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    25% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg);
    }
    37.5% {
      -webkit-transform: rotate(405deg);
      transform: rotate(405deg);
    }
    50% {
      -webkit-transform: rotate(540deg);
      transform: rotate(540deg);
    }
    62.5% {
      -webkit-transform: rotate(675deg);
      transform: rotate(675deg);
    }
    75% {
      -webkit-transform: rotate(810deg);
      transform: rotate(810deg);
    }
    87.5% {
      -webkit-transform: rotate(945deg);
      transform: rotate(945deg);
    }
    to {
      -webkit-transform: rotate(1080deg);
      transform: rotate(1080deg);
    }
  }
  @-moz-keyframes theo-spinner-easespin {
    12.5% {
      -moz-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    25% {
      -moz-transform: rotate(270deg);
      transform: rotate(270deg);
    }
    37.5% {
      -moz-transform: rotate(405deg);
      transform: rotate(405deg);
    }
    50% {
      -moz-transform: rotate(540deg);
      transform: rotate(540deg);
    }
    62.5% {
      -moz-transform: rotate(675deg);
      transform: rotate(675deg);
    }
    75% {
      -moz-transform: rotate(810deg);
      transform: rotate(810deg);
    }
    87.5% {
      -moz-transform: rotate(945deg);
      transform: rotate(945deg);
    }
    to {
      -moz-transform: rotate(1080deg);
      transform: rotate(1080deg);
    }
  }
  @keyframes theo-spinner-easespin {
    12.5% {
      -webkit-transform: rotate(135deg);
      -moz-transform: rotate(135deg);
      transform: rotate(135deg);
    }
    25% {
      -webkit-transform: rotate(270deg);
      -moz-transform: rotate(270deg);
      transform: rotate(270deg);
    }
    37.5% {
      -webkit-transform: rotate(405deg);
      -moz-transform: rotate(405deg);
      transform: rotate(405deg);
    }
    50% {
      -webkit-transform: rotate(540deg);
      -moz-transform: rotate(540deg);
      transform: rotate(540deg);
    }
    62.5% {
      -webkit-transform: rotate(675deg);
      -moz-transform: rotate(675deg);
      transform: rotate(675deg);
    }
    75% {
      -webkit-transform: rotate(810deg);
      -moz-transform: rotate(810deg);
      transform: rotate(810deg);
    }
    87.5% {
      -webkit-transform: rotate(945deg);
      -moz-transform: rotate(945deg);
      transform: rotate(945deg);
    }
    to {
      -webkit-transform: rotate(1080deg);
      -moz-transform: rotate(1080deg);
      transform: rotate(1080deg);
    }
  }
  @-webkit-keyframes theo-spinner-left-spin {
    0%,
    to {
      -webkit-transform: rotate(130deg);
      transform: rotate(130deg);
    }
    50% {
      -webkit-transform: rotate(-5deg);
      transform: rotate(-5deg);
    }
  }
  @-moz-keyframes theo-spinner-left-spin {
    0%,
    to {
      -moz-transform: rotate(130deg);
      transform: rotate(130deg);
    }
    50% {
      -moz-transform: rotate(-5deg);
      transform: rotate(-5deg);
    }
  }
  @keyframes theo-spinner-left-spin {
    0%,
    to {
      -webkit-transform: rotate(130deg);
      -moz-transform: rotate(130deg);
      transform: rotate(130deg);
    }
    50% {
      -webkit-transform: rotate(-5deg);
      -moz-transform: rotate(-5deg);
      transform: rotate(-5deg);
    }
  }
  @-webkit-keyframes theo-spinner-right-spin {
    0%,
    to {
      -webkit-transform: rotate(-130deg);
      transform: rotate(-130deg);
    }
    50% {
      -webkit-transform: rotate(5deg);
      transform: rotate(5deg);
    }
  }
  @-moz-keyframes theo-spinner-right-spin {
    0%,
    to {
      -moz-transform: rotate(-130deg);
      transform: rotate(-130deg);
    }
    50% {
      -moz-transform: rotate(5deg);
      transform: rotate(5deg);
    }
  }
  @keyframes theo-spinner-right-spin {
    0%,
    to {
      -webkit-transform: rotate(-130deg);
      -moz-transform: rotate(-130deg);
      transform: rotate(-130deg);
    }
    50% {
      -webkit-transform: rotate(5deg);
      -moz-transform: rotate(5deg);
      transform: rotate(5deg);
    }
  }
  .theoplayer-skin.vjs-has-started.vjs-user-inactive.vjs-playing:not(
      .theo-menu-opened
    )
    .vjs-control-bar {
    opacity: 0;
  }
  .theoplayer-skin.vjs-has-started.vjs-user-inactive.vjs-playing.theo-menu-opened
    .vjs-control-bar {
    opacity: 1;
  }
  .theoplayer-skin.theo-menu-opened .theo-button-tooltip {
    visibility: hidden;
  }
  .theoplayer-skin .theo-menu {
    position: absolute;
    bottom: 4em;
    min-width: 10em;
    max-width: 22em;
    max-height: 21em;
    overflow-y: auto;
    text-shadow: none;
    cursor: pointer;
    background-color: rgba(28, 28, 28, 0.9);
  }
  .theoplayer-skin .theo-menu::-webkit-scrollbar-track {
    background-color: #424242;
  }
  .theoplayer-skin .theo-menu::-webkit-scrollbar {
    width: 10px;
  }
  .theoplayer-skin .theo-menu::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #8e8e8e;
    border: 1px #424242 solid;
  }
  .theoplayer-skin .theo-menu-header,
  .theoplayer-skin .theo-menu-item {
    font-family: Arial, Helvetica, sans-serif;
    text-transform: capitalize;
    padding: 0.4em 1em;
    font-size: 1.2em;
    line-height: 1.2em;
  }
  .theoplayer-skin .theo-menu-header:focus,
  .theoplayer-skin .theo-menu-header:hover,
  .theoplayer-skin .theo-menu-item:focus,
  .theoplayer-skin .theo-menu-item:hover {
    outline: 0;
  }
  .theoplayer-skin .theo-menu-header {
    text-align: center;
    margin-bottom: 0.2em;
    line-height: 1.4em;
  }
  .theoplayer-skin .theo-menu-content {
    padding: 0;
  }
  .theoplayer-skin .theo-subtitle-options-menu-item {
    font-size: 1.1em;
  }
  .theoplayer-skin .theo-menu.theo-menu-animatable {
    overflow: visible;
    background: none;
  }
  .theoplayer-skin
    .theo-menu.theo-menu-animatable
    .theo-menu-animation-container {
    max-width: 22em;
  }
  .theoplayer-skin
    .theo-menu.theo-menu-animatable
    .theo-menu-animation-container {
    position: absolute;
    right: 0;
    bottom: 0;
    overflow: hidden;
    -webkit-transition:
      width 0.2s cubic-bezier(0.4, 0, 1, 1),
      height 0.2s cubic-bezier(0.4, 0, 1, 1);
    -moz-transition:
      width 0.2s cubic-bezier(0.4, 0, 1, 1),
      height 0.2s cubic-bezier(0.4, 0, 1, 1);
    transition:
      width 0.2s cubic-bezier(0.4, 0, 1, 1),
      height 0.2s cubic-bezier(0.4, 0, 1, 1);
  }
  .theoplayer-skin
    .theo-menu.theo-menu-animatable
    .theo-menu-content-animatable {
    bottom: 0;
    right: 0;
    -webkit-transition:
      opacity 0.3s cubic-bezier(0, 0, 0.2, 1),
      -webkit-transform 0.2s cubic-bezier(0.4, 0, 1, 1);
    transition:
      opacity 0.3s cubic-bezier(0, 0, 0.2, 1),
      -webkit-transform 0.2s cubic-bezier(0.4, 0, 1, 1);
    -moz-transition:
      opacity 0.3s cubic-bezier(0, 0, 0.2, 1),
      transform 0.2s cubic-bezier(0.4, 0, 1, 1),
      -moz-transform 0.2s cubic-bezier(0.4, 0, 1, 1);
    transition:
      opacity 0.3s cubic-bezier(0, 0, 0.2, 1),
      transform 0.2s cubic-bezier(0.4, 0, 1, 1);
    transition:
      opacity 0.3s cubic-bezier(0, 0, 0.2, 1),
      transform 0.2s cubic-bezier(0.4, 0, 1, 1),
      -webkit-transform 0.2s cubic-bezier(0.4, 0, 1, 1),
      -moz-transform 0.2s cubic-bezier(0.4, 0, 1, 1);
    position: absolute;
    background: none;
  }
  .theoplayer-skin .theo-submenu .theo-menu-header {
    padding: 5px 10px 5px 24px;
    background-image: url("data:image/svg+xml,%3Csvg fill='%23000000' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z'/%3E%3C/svg%3E");
    background-position: left center;
    background-repeat: no-repeat;
  }
  .theoplayer-skin .theo-submenu .theo-menu-content {
    position: relative;
    bottom: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
  }
  .theoplayer-skin .theo-submenu .theo-menu-item {
    display: block;
    text-align: right;
    text-transform: capitalize;
    position: relative;
  }
  .theoplayer-skin .theo-submenu .theo-menu-item.vjs-selected {
    font-weight: bold;
  }
  .theoplayer-skin .theo-menu .theo-menu-item {
    width: 100%;
    height: auto;
    text-align: center;
    list-style-type: none;
  }
  .theoplayer-skin .theo-menu .theo-menu-item:focus,
  .theoplayer-skin .theo-menu .theo-menu-item:hover {
    color: inherit;
    background-color: rgba(255, 255, 255, 0.1);
  }
  .theoplayer-skin .theo-menu .theo-menu-item.vjs-selected,
  .theoplayer-skin .theo-menu .theo-menu-item.vjs-selected:focus,
  .theoplayer-skin .theo-menu .theo-menu-item.vjs-selected:hover {
    color: #ffc50f;
    background-color: rgba(255, 255, 255, 0.2);
  }
  .theoplayer-skin .theo-menu-item.theo-text-track-menu-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    transition: all 0.2s;
    font-weight: normal;
  }
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item
    .theo-text-track-menu-item-toggle {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 1em;
    width: 2.2em;
    height: 0.9em;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    margin-left: 1em;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -moz-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    opacity: 0.3;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    transition: all 0.2s;
  }
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item
    .theo-text-track-menu-item-toggle
    .theo-text-track-menu-item-toggle-slider {
    background-color: #949494;
    width: 1.2em;
    height: 1.2em;
    border-radius: 50%;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    transition: all 0.2s;
  }
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item.vjs-selected
    .theo-text-track-menu-item-toggle,
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item:hover
    .theo-text-track-menu-item-toggle {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.4);
  }
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item.vjs-selected
    .theo-text-track-menu-item-toggle
    .theo-text-track-menu-item-toggle-slider,
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item:hover
    .theo-text-track-menu-item-toggle
    .theo-text-track-menu-item-toggle-slider {
    background-color: #d0d0d0;
  }
  .theoplayer-skin
    .theo-menu-item.theo-text-track-menu-item.vjs-selected
    .theo-text-track-menu-item-toggle {
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
  }
  .theoplayer-skin .theo-menu.theo-settings-control-menu,
  .theoplayer-skin
    .theo-menu.theo-settings-control-menu
    .theo-menu-content-animatable {
    min-width: 18em;
  }
  .theoplayer-skin .theo-menu.theo-settings-control-menu .theo-submenu {
    min-width: 10em;
  }
  .theoplayer-skin
    .theo-menu.theo-settings-control-menu
    .theo-submenu
    .theo-menu-item:last-child {
    margin-bottom: 0.4em;
  }
  .theoplayer-skin
    .theo-menu.theo-settings-control-menu
    .theo-submenu
    .theo-menu-item {
    padding-right: 1em;
  }
  .theoplayer-skin .theo-menu.theo-settings-control-menu .theo-menu-item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: baseline;
    -webkit-align-items: baseline;
    -moz-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    position: relative;
    white-space: nowrap;
    padding-right: 2em;
  }
  .theoplayer-skin
    .theo-menu.theo-settings-control-menu
    .theo-submenu.theo-leaf-submenu
    .theo-menu-item {
    display: block;
  }
  .theoplayer-skin .theo-settings-control-menu-item-title {
    font-weight: 600;
    padding-right: 0.5em;
  }
  .theoplayer-skin .theo-settings-control-menu-item-value {
    font-size: 0.9em;
  }
  .theoplayer-skin .theo-context-menu {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    padding: 5px 5px;
    margin: 2px 0 0;
    list-style: none;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;
    text-align: left;
    overflow: hidden;
    text-shadow: none;
    cursor: pointer;
    background-color: rgba(28, 28, 28, 0.9);
    text-decoration: none;
  }
  .theoplayer-skin .theo-context-menu:hover {
    background-color: rgba(14, 14, 14, 0.9);
  }
  .theoplayer-skin .theo-context-menu .theo-context-menu-a {
    text-decoration: none;
  }
  .theoplayer-skin
    .theo-context-menu
    .theo-context-menu-a
    .theo-context-menu-logo {
    float: left;
    position: relative;
    top: 4.3px;
  }
  .theoplayer-skin
    .theo-context-menu
    .theo-context-menu-a
    .theo-context-menu-logo
    .theo-context-menu-logo-svg {
    width: 30px;
    height: 15px;
  }
  .theoplayer-skin
    .theo-context-menu
    .theo-context-menu-a
    .theo-context-version {
    font-size: 11px;
    text-align: center;
    line-height: 20px;
    color: #fff;
    text-decoration: none;
    width: 200px;
  }
  .theoplayer-skin .theo-settings-control-menu-quality-automatic {
    color: rgba(255, 255, 255, 0.9);
    text-transform: uppercase;
    font-size: 0.7em;
  }
  .theoplayer-skin .theo-settings-control-menu-item-hd-label {
    display: inline;
    content: "HD";
    font-weight: bold;
    font-size: 0.7em;
    margin-left: 0.2em;
    position: absolute;
    top: 0;
    right: 0.6em;
  }
  .theoplayer-skin .theo-settings-control-submenu-item-alternate-value {
    font-size: 0.55em;
    margin-top: 1.5em;
    margin-left: 0.5em;
    vertical-align: sub;
    font-weight: normal;
    text-transform: none;
    position: absolute;
    right: 0.6em;
  }
  .theoplayer-skin.theo-mobile {
    -webkit-tap-highlight-color: transparent;
  }
  .theoplayer-skin.theo-mobile.vjs-fullscreen {
    font-size: 12px;
  }
  .theoplayer-skin.theo-mobile.video-js .vjs-control:before {
    font-size: 2.1em;
    line-height: 1.4em;
  }
  .theoplayer-skin.theo-mobile .vjs-play-progress:before {
    -webkit-transform: translate(50%, -50%) scale(1);
    -moz-transform: translate(50%, -50%) scale(1);
    transform: translate(50%, -50%) scale(1);
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
  }
  .theoplayer-skin.theo-mobile .vjs-duration.vjs-time-control {
    position: absolute;
    top: -3.3em;
    right: 1em;
    text-shadow: 0 0 1em #000;
    font-size: 1.3em;
  }
  .theoplayer-skin.theo-mobile .vjs-current-time,
  .theoplayer-skin.theo-mobile .vjs-time-divider,
  .theoplayer-skin.theo-mobile .vjs-remaining-time,
  .theoplayer-skin.theo-mobile .vjs-volume-control {
    display: none;
  }
  .theoplayer-skin.theo-mobile:not(.theo-seekbar-inside-controls)
    .vjs-progress-control {
    padding-top: 2.5em;
    padding-bottom: 0.8em;
    margin-bottom: -0.8em;
  }
  .theoplayer-skin.theo-mobile:not(.theo-seekbar-inside-controls)
    .vjs-progress-control
    .vjs-progress-holder {
    font-size: 1.66667em;
    height: 0.3em;
  }
  .theoplayer-skin.theo-mobile:not(.theo-seekbar-inside-controls)
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-time-tooltip {
    visibility: visible;
    right: -1.7em;
    bottom: -0.35em;
    font-size: 0.8em;
    padding: 0.3em;
  }
  .theoplayer-skin.theo-mobile:not(.theo-seekbar-inside-controls)
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-play-progress:before {
    font-size: 0.9em;
  }
  .theoplayer-skin.theo-mobile:not(.theo-seekbar-inside-controls)
    .vjs-progress-control
    .vjs-progress-holder
    .vjs-mouse-display {
    visibility: visible;
    display: block;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0);
  }
  .theoplayer-skin.theo-mobile .vjs-button,
  .theoplayer-skin.theo-mobile .vjs-button:before {
    -webkit-transition: text-shadow 0.2s ease-in-out;
    -moz-transition: text-shadow 0.2s ease-in-out;
    transition: text-shadow 0.2s ease-in-out;
  }
  .theoplayer-skin.theo-mobile .vjs-button:hover:before {
    text-shadow: none;
  }
  .theoplayer-skin.theo-mobile .vjs-button.theo-mobile-button-hover,
  .theoplayer-skin.theo-mobile .vjs-button.theo-mobile-button-hover:before {
    text-shadow: 0 0 1em #fff;
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
  }
  .theoplayer-skin.theo-mobile .theo-mobile-menu-background {
    opacity: 0;
  }
  .theoplayer-skin.theo-mobile .theo-menu.theo-menu-animatable {
    position: absolute;
    top: auto;
    bottom: 50%;
    -webkit-transform: translateY(50%);
    -moz-transform: translateY(50%);
    transform: translateY(50%);
    left: 15%;
    right: 15%;
    width: 70%;
    max-width: 70%;
    max-height: 100%;
    overflow-y: auto;
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
    z-index: 2;
  }
  .theoplayer-skin.theo-mobile .theo-menu.theo-menu-animatable .theo-menu,
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-animation-container {
    position: static;
    width: 100%;
    height: 100%;
    max-width: none;
    max-height: none;
    overflow: visible;
  }
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-header {
    padding: 1em;
  }
  .theoplayer-skin.theo-mobile .theo-menu.theo-menu-animatable .theo-menu-item {
    height: 4em;
    padding-left: 1em;
    line-height: 3.4em;
  }
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-item.theo-mobile-menu-item-hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-item:focus,
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-item:hover {
    background-color: transparent;
  }
  .theoplayer-skin.theo-mobile
    .theo-menu.theo-menu-animatable
    .theo-menu-animation-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
    bottom: auto;
    right: auto;
    max-width: none;
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
  }
  .theoplayer-skin.theo-mobile .theo-settings-control-menu-item-title {
    -webkit-align-self: auto;
    -ms-flex-item-align: auto;
    align-self: auto;
  }
  .theoplayer-skin.theo-mobile .theo-settings-control-menu-item-value {
    font-size: 1em;
  }
  .theoplayer-skin.theo-mobile .theo-submenu .theo-submenu-content {
    overflow-y: hidden;
  }
  .theoplayer-skin.theo-mobile .theo-subtitle-options-menu-item {
    float: left;
  }
  .theoplayer-skin.theo-mobile.theo-mobile-portrait
    .theo-submenu.theo-leaf-submenu
    .theo-menu-item {
    width: 50%;
    float: left;
  }
  .theoplayer-skin.theo-mobile.theo-mobile-portrait
    .theo-submenu
    .theo-menu-item.theo-subtitle-options-menu-item {
    width: 100%;
  }
  .theoplayer-skin.theo-mobile.theo-mobile-landscape
    .theo-submenu
    .theo-menu-item {
    width: 50%;
    float: left;
  }
  .theoplayer-skin.theo-mobile.theo-mobile-landscape
    .theo-submenu.theo-leaf-submenu
    .theo-menu-item {
    width: 33.33%;
    float: left;
  }
  .theoplayer-skin.theo-mobile.theo-mobile-landscape
    .theo-submenu
    .theo-menu-item.theo-subtitle-options-menu-item {
    width: 100%;
  }
  .theoplayer-skin.theo-mobile.theo-pip-enabled .vjs-tech,
  .theoplayer-skin.theo-mobile.theo-pip-enabled .vjs-control-bar {
    width: 85%;
    left: 7.5%;
    right: 7.5%;
    height: auto;
  }
  .theoplayer-skin.theo-mobile
    .theoplayer-ad-overlay-component.theoplayer-ad-touch-clickthrough {
    top: 2.7em;
  }
  .theoplayer-skin.theo-mobile.theo-ad-playing .vjs-duration-display {
    display: none;
  }
  .theoplayer-skin.theo-mobile .theo-button-tooltip {
    visibility: hidden;
  }
  .theoplayer-chapterbar {
    height: 100%;
    width: 100%;
  }
  .theoplayer-chapterbar .theoplayer-chapter-indicator {
    position: absolute;
    height: 100%;
    border-left: 1px solid #000;
  }
  .theoplayer-chapterbar
    .theoplayer-chapter-indicator
    .theoplayer-chapter-indicator-highlight {
    position: absolute;
    left: 0;
    bottom: 100%;
    width: 100%;
    height: 0;
    padding-top: 2px;
    border-top: 2px solid transparent;
  }
  .theoplayer-chapterbar
    .theoplayer-chapter-indicator.theoplayer-chapter-indicator-discontinuous {
    border-right: 1px solid #000;
  }
  .theoplayer-chapterbar
    .theoplayer-chapter-indicator:hover
    .theoplayer-chapter-indicator-highlight {
    border-top-color: rgba(255, 255, 255, 0.8);
  }
  .theoplayer-chaptertitle {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.4s ease-in;
    -moz-transition: opacity 0.4s ease-in;
    transition: opacity 0.4s ease-in;
    opacity: 0;
  }
  .theoplayer-chaptertitle p {
    font-size: 2.5em;
    color: #fff;
    padding: 0.3em;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 0.3em;
    margin: 0;
  }
  .vjs-user-active .theoplayer-chaptertitle.theoplayer-chapter-hovering {
    opacity: 1;
  }
  .theoplayer-skin.video-js .vjs-button .theo-button-icon-blur {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.2);
    width: 60%;
    height: 70%;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    -webkit-filter: blur(4px);
    filter: blur(4px);
    visibility: hidden;
  }
  .theoplayer-skin.video-js .vjs-button:hover .theo-button-icon-blur,
  .theoplayer-skin.video-js .vjs-button:focus .theo-button-icon-blur {
    visibility: visible;
  }
  .video-js .theo-close-button {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    outline: none;
    margin: 0;
    padding: 0;
    z-index: 11;
  }
  .theoplayer-skin .theo-close-button {
    padding: 0.5em;
    font-size: 1.35em;
    font-weight: bold;
    text-align: center;
  }
  .theoplayer-skin .theo-close-button:focus:before,
  .theoplayer-skin .theo-close-button:hover:before {
    text-shadow: 0 0 1em #fff;
  }
  .theoplayer-skin .theo-player-wrapper .vjs-control-bar.theo-top-controlbar {
    top: 0;
    height: 4em;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -webkit-flex-direction: row-reverse;
    -moz-box-orient: horizontal;
    -moz-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
    visibility: hidden;
    margin: 0.75em;
    padding: 0;
    width: auto;
  }
  .theo-player-wrapper
    .vjs-control-bar.theo-top-controlbar
    .theo-control-bar-shadow {
    display: none;
  }
  .theo-player-wrapper
    .vjs-control-bar.theo-top-controlbar
    .theo-button-tooltip {
    top: 100%;
    bottom: auto;
    margin-top: 0.3em;
  }
  .theo-pip.theoplayer-skin
    .theo-player-wrapper
    .vjs-control-bar.theo-top-controlbar {
    display: none;
  }
  .theo-player-wrapper .vjs-control-bar.theo-top-controlbar .vjs-button {
    visibility: visible;
    background-color: rgba(33, 33, 33, 0.8);
    border-radius: 100%;
    height: 3em;
    width: 3em;
    margin: 0.5em;
  }
  .theo-quality-label {
    cursor: default;
    display: none;
    font-family: Arial, Helvetica, sans-serif;
    height: 45%;
    margin: auto;
    text-align: right;
    width: 100px;
    right: 0;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -moz-box-orient: horizontal;
    -moz-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: right;
    -webkit-align-items: right;
    -moz-box-align: right;
    -ms-flex-align: right;
    align-items: right;
  }
  .theo-quality-label-text {
    background-color: #333;
    border-radius: 3px;
    font-size: 0.87em;
    padding: 3px;
    vertical-align: middle;
    text-align: right;
    margin-right: 5px;
  }
  .theo-quality-label-show {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
  }
  .theo-quality-label-fadeout {
    -webkit-transition: opacity 0.25s linear;
    -moz-transition: opacity 0.25s linear;
    transition: opacity 0.25s linear;
    opacity: 0;
  }
  .theo-chromecast-button {
    -webkit-box-ordinal-group: 99;
    -webkit-order: 98;
    -moz-box-ordinal-group: 99;
    -ms-flex-order: 98;
    order: 98;
  }
  .theo-chromecast-unavailable .theo-chromecast-button {
    display: none;
  }
  .theo-chromecast-button .theo-chromecast-rings {
    -webkit-clip-path: polygon(50% -100%, 50% 50%, 100% 50%, 100% -100%);
    clip-path: polygon(50% -100%, 50% 50%, 100% 50%, 100% -100%);
  }
  .theo-chromecast-button .theo-chromecast-inner {
    opacity: 0;
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }
  .theo-chromecast-connected .theo-chromecast-button .theo-chromecast-inner {
    opacity: 1;
  }
  .theo-chromecast-connecting .theo-chromecast-button .theo-chromecast-ring {
    -webkit-animation: 0.9s linear infinite;
    -moz-animation: 0.9s linear infinite;
    animation: 0.9s linear infinite;
  }
  .theo-chromecast-connecting .theo-chromecast-button .theo-chromecast-ring1 {
    -webkit-animation-name: theo-chromecast-connecting-ring1;
    -moz-animation-name: theo-chromecast-connecting-ring1;
    animation-name: theo-chromecast-connecting-ring1;
  }
  .theo-chromecast-connecting .theo-chromecast-button .theo-chromecast-ring2 {
    -webkit-animation-name: theo-chromecast-connecting-ring2;
    -moz-animation-name: theo-chromecast-connecting-ring2;
    animation-name: theo-chromecast-connecting-ring2;
  }
  .theo-chromecast-connecting .theo-chromecast-button .theo-chromecast-ring3 {
    -webkit-animation-name: theo-chromecast-connecting-ring3;
    -moz-animation-name: theo-chromecast-connecting-ring3;
    animation-name: theo-chromecast-connecting-ring3;
  }
  .theo-chromecast-connecting .theo-chromecast-button .theo-chromecast-ring4 {
    -webkit-animation-name: theo-chromecast-connecting-ring4;
    -moz-animation-name: theo-chromecast-connecting-ring4;
    animation-name: theo-chromecast-connecting-ring4;
  }
  @-webkit-keyframes theo-chromecast-connecting-ring1 {
    0%,
    37.5% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    62.5%,
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @-moz-keyframes theo-chromecast-connecting-ring1 {
    0%,
    37.5% {
      -moz-transform: scale(0);
      transform: scale(0);
    }
    62.5%,
    100% {
      -moz-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes theo-chromecast-connecting-ring1 {
    0%,
    37.5% {
      -webkit-transform: scale(0);
      -moz-transform: scale(0);
      transform: scale(0);
    }
    62.5%,
    100% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transform: scale(1);
    }
  }
  @-webkit-keyframes theo-chromecast-connecting-ring2 {
    0%,
    20% {
      -webkit-transform: scale(0.25);
      transform: scale(0.25);
      stroke-width: 24;
    }
    35% {
      -webkit-transform: scale(0.5);
      transform: scale(0.5);
      stroke-width: 10;
    }
    55%,
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @-moz-keyframes theo-chromecast-connecting-ring2 {
    0%,
    20% {
      -moz-transform: scale(0.25);
      transform: scale(0.25);
      stroke-width: 24;
    }
    35% {
      -moz-transform: scale(0.5);
      transform: scale(0.5);
      stroke-width: 10;
    }
    55%,
    100% {
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @keyframes theo-chromecast-connecting-ring2 {
    0%,
    20% {
      -webkit-transform: scale(0.25);
      -moz-transform: scale(0.25);
      transform: scale(0.25);
      stroke-width: 24;
    }
    35% {
      -webkit-transform: scale(0.5);
      -moz-transform: scale(0.5);
      transform: scale(0.5);
      stroke-width: 10;
    }
    55%,
    100% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @-webkit-keyframes theo-chromecast-connecting-ring3 {
    0%,
    15% {
      -webkit-transform: scale(0.6);
      transform: scale(0.6);
      stroke-width: 6.66667;
    }
    45%,
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @-moz-keyframes theo-chromecast-connecting-ring3 {
    0%,
    15% {
      -moz-transform: scale(0.6);
      transform: scale(0.6);
      stroke-width: 6.66667;
    }
    45%,
    100% {
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @keyframes theo-chromecast-connecting-ring3 {
    0%,
    15% {
      -webkit-transform: scale(0.6);
      -moz-transform: scale(0.6);
      transform: scale(0.6);
      stroke-width: 6.66667;
    }
    45%,
    100% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
    }
  }
  @-webkit-keyframes theo-chromecast-connecting-ring4 {
    0% {
      opacity: 1;
      -webkit-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
      stroke-dashoffset: 0;
      stroke-dasharray: 32, 99;
    }
    35% {
      opacity: 1;
      -webkit-transform: scale(1.4);
      transform: scale(1.4);
      stroke-width: 2.8571;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50% {
      opacity: 1;
      -webkit-transform: scale(1.5);
      transform: scale(1.5);
      stroke-width: 0;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50.001%,
    100% {
      opacity: 0;
    }
  }
  @-moz-keyframes theo-chromecast-connecting-ring4 {
    0% {
      opacity: 1;
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
      stroke-dashoffset: 0;
      stroke-dasharray: 32, 99;
    }
    35% {
      opacity: 1;
      -moz-transform: scale(1.4);
      transform: scale(1.4);
      stroke-width: 2.8571;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50% {
      opacity: 1;
      -moz-transform: scale(1.5);
      transform: scale(1.5);
      stroke-width: 0;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50.001%,
    100% {
      opacity: 0;
    }
  }
  @keyframes theo-chromecast-connecting-ring4 {
    0% {
      opacity: 1;
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transform: scale(1);
      stroke-width: 4;
      stroke-dashoffset: 0;
      stroke-dasharray: 32, 99;
    }
    35% {
      opacity: 1;
      -webkit-transform: scale(1.4);
      -moz-transform: scale(1.4);
      transform: scale(1.4);
      stroke-width: 2.8571;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50% {
      opacity: 1;
      -webkit-transform: scale(1.5);
      -moz-transform: scale(1.5);
      transform: scale(1.5);
      stroke-width: 0;
      stroke-dashoffset: -18;
      stroke-dasharray: 0, 99;
    }
    50.001%,
    100% {
      opacity: 0;
    }
  }
  .theo-chromecast-overlay {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
    pointer-events: none;
  }
  .theo-chromecast-connected .theo-chromecast-overlay {
    display: block;
  }
  .theo-chromecast-overlay .theo-chromecast-status {
    position: absolute;
    left: 35px;
    right: 35px;
    bottom: 4em;
    opacity: 0.7;
  }
  .theo-chromecast-overlay .theo-chromecast-status-icon {
    float: left;
    width: 80px;
    height: 80px;
  }
  .theo-chromecast-overlay .theo-chromecast-status-info {
    font-size: 130%;
    font-weight: 500;
    text-transform: uppercase;
    top: 18px;
  }
  .theo-chromecast-overlay .theo-chromecast-status-title {
    font-size: 250%;
    top: 35px;
  }
  .theo-chromecast-overlay .theo-chromecast-status-info,
  .theo-chromecast-overlay .theo-chromecast-status-title {
    position: absolute;
    left: 75px;
    text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  }
  .theo-airplay-button {
    -webkit-box-ordinal-group: 98;
    -webkit-order: 97;
    -moz-box-ordinal-group: 98;
    -ms-flex-order: 97;
    order: 97;
  }
  .theo-airplay-unavailable .theo-airplay-button {
    display: none;
  }
  .theo-airplay-button .theo-cast-inner {
    opacity: 0;
    -webkit-transition: opacity 0.5s ease-in-out;
    -moz-transition: opacity 0.5s ease-in-out;
    transition: opacity 0.5s ease-in-out;
  }
  .theo-airplay-connected .theo-airplay-button .theo-cast-inner {
    opacity: 1;
  }
  .theo-airplay-connected .theo-audio-track-control-button,
  .theo-airplay-connected .theo-text-track-control-button,
  .theo-airplay-connected .vjs-volume-control,
  .theo-airplay-connected .vjs-mute-control {
    display: none;
  }
  .video-js .vjs-control.theo-cast-button .theo-cast-svg-container {
    width: 100%;
    height: 100%;
  }
  .video-js .vjs-control.theo-cast-button svg {
    color: inherit;
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    pointer-events: none;
    margin: 0.5em;
  }
  .theoplayer-skin .theoplayer-ad-skip,
  .theoplayer-skin .theoplayer-ad-overlay-component {
    color: #fff;
    background-color: rgba(51, 51, 51, 0.6);
    z-index: 12;
    padding: 1em;
    cursor: pointer;
    font-size: 1.25em;
  }
  .theoplayer-skin .theoplayer-ad-skip.theo-ad-remaining-container,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theo-ad-remaining-container {
    top: 0;
    position: absolute;
    width: 100%;
    text-align: center;
    padding: 0.5em;
  }
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-skip-countdown,
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-skip-button,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-skip-countdown,
  .theoplayer-skin .theoplayer-ad-overlay-component.theoplayer-ad-skip-button {
    bottom: 3.2em;
  }
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-skip,
  .theoplayer-skin .theoplayer-ad-overlay-component.theoplayer-ad-skip {
    padding: 0;
    position: absolute;
    line-height: 4em;
    height: 4em;
    right: 0;
  }
  .theoplayer-skin
    .theoplayer-ad-skip.theoplayer-ad-skip.theo-size-xs
    .theoplayer-ad-skip-poster,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-skip.theo-size-xs
    .theoplayer-ad-skip-poster {
    display: none;
  }
  .theoplayer-skin
    .theoplayer-ad-skip.theoplayer-ad-skip.theo-size-xs.theoplayer-ad-skip-countdown,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-skip.theo-size-xs.theoplayer-ad-skip-countdown {
    line-height: 2em;
    height: 2em;
    bottom: 3.5em;
  }
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-skip span,
  .theoplayer-skin .theoplayer-ad-overlay-component.theoplayer-ad-skip span {
    display: table-cell;
    padding: 0 1em;
    position: relative;
  }
  .theoplayer-skin
    .theoplayer-ad-skip.theoplayer-ad-skip
    .theoplayer-ad-skip-poster,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-skip
    .theoplayer-ad-skip-poster {
    width: 7em;
    height: 4em;
    display: table-cell;
    background-size: cover;
    background-position: center;
  }
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-skip-countdown,
  .theoplayer-skin .theoplayer-ad-skip.theo-ad-remaining-container,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-skip-countdown,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theo-ad-remaining-container {
    cursor: default;
  }
  .theoplayer-skin .theoplayer-ad-skip.theoplayer-ad-touch-clickthrough,
  .theoplayer-skin
    .theoplayer-ad-overlay-component.theoplayer-ad-touch-clickthrough {
    top: 1em;
    right: 0;
  }
  .theoplayer-ad-nonlinear
    .theoplayer-ad-nonlinear-content
    .theoplayer-ad-nonlinear-close:before {
    display: inline-block;
    content: "×";
    padding: 0.1em 0.15em 0.12em 0.2em;
    color: #fff;
    text-shadow:
      -1px 0 #000,
      0 1px #000,
      1px 0 #000,
      0 -1px #000;
  }
  .theoplayer-ad-nonlinear
    .theoplayer-ad-nonlinear-content
    .theoplayer-ad-nonlinear-close:hover:before {
    text-shadow:
      -1px 0 0.8em #000,
      0 1px 0.8em #000,
      1px 0 0.8em #000,
      0 -1px 0.8em #000;
  }
  .theo-ad-playing .vjs-progress-control {
    pointer-events: none;
    cursor: default;
  }
  .theo-ad-playing .theo-settings-control-button,
  .theo-ad-playing .theo-settings-control-menu {
    display: none !important;
  }
  .theo-dai-clickthrough,
  .theo-dai-countdown {
    opacity: 0;
    display: none;
  }
  .theo-dai-clickthrough {
    font-weight: bold;
    color: #fff;
    background: rgba(51, 51, 51, 0.6) none;
    position: absolute;
    height: auto;
    z-index: 10;
    width: auto;
    padding: 0.65em;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .vjs-has-started.theo-dai-ad-playing .theo-top-controlbar {
    display: none;
  }
  .vjs-has-started.theo-dai-ad-playing .theo-dai-countdown {
    opacity: 1;
    display: block;
    background: rgba(51, 51, 51, 0.4);
    bottom: 4em;
    padding: 0.65em;
    color: #fff;
    position: absolute;
    left: 2em;
    right: auto;
    z-index: 10;
    visibility: visible;
    width: auto;
    min-width: 0;
  }
  .vjs-has-started.theo-dai-ad-playing .theo-dai-countdown:before {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    background: -webkit-gradient(
      linear,
      left bottom,
      left top,
      from(rgba(0, 0, 0, 0.3)),
      to(transparent)
    );
    background: -webkit-linear-gradient(
      bottom,
      rgba(0, 0, 0, 0.3),
      transparent
    );
    background: -moz-linear-gradient(bottom, rgba(0, 0, 0, 0.3), transparent);
    background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
    z-index: -1;
    opacity: 0;
  }
  .vjs-has-started.theo-dai-ad-playing .theo-dai-clickthrough {
    opacity: 1;
    display: block;
  }
  .vjs-has-started.theo-dai-ad-playing .theo-dai-clickthrough:focus {
    background-color: #333;
  }
  .vjs-has-started.theo-dai-ad-playing.vjs-user-inactive.vjs-playing:not(
      .theo-menu-opened
    )
    .theo-dai-countdown {
    bottom: 0;
    left: 0;
    min-width: 100%;
    -webkit-transition-duration: 0s;
    -moz-transition-duration: 0s;
    transition-duration: 0s;
    background-color: transparent;
    text-shadow: #000 1px 1px 2px;
    padding-top: 1em;
    -webkit-transition:
      left 0s 0.45s,
      min-width 0s 0.45s,
      text-shadow 0s 0.45s,
      bottom 0.15s 0.45s,
      background-color 0.15s 0.45s,
      padding-top 0.15s 0.45s;
    -moz-transition:
      left 0s 0.45s,
      min-width 0s 0.45s,
      text-shadow 0s 0.45s,
      bottom 0.15s 0.45s,
      background-color 0.15s 0.45s,
      padding-top 0.15s 0.45s;
    transition:
      left 0s 0.45s,
      min-width 0s 0.45s,
      text-shadow 0s 0.45s,
      bottom 0.15s 0.45s,
      background-color 0.15s 0.45s,
      padding-top 0.15s 0.45s;
  }
  .vjs-has-started.theo-dai-ad-playing.vjs-user-inactive.vjs-playing:not(
      .theo-menu-opened
    )
    .theo-dai-countdown:before {
    opacity: 1;
    -webkit-transition: opacity 0s 0.45s;
    -moz-transition: opacity 0s 0.45s;
    transition: opacity 0s 0.45s;
  }
  .theo-freewheel,
  .theo-freewheel-video {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
  }
  .freewheel-nonlinear-ad .theo-freewheel {
    bottom: 3.5em;
  }
  .theoplayer-yospace-advert {
    top: 0;
    left: 0;
  }
  .theo-vdms-adbreak-marker-controller {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  .theo-vdms-marker {
    position: absolute;
    height: 100%;
  }
  .theo-vdms-marker-adbreak {
    background-color: rgba(255, 0, 0, 0.3);
  }
  .theo-vdms-marker-asset {
    border-left: 1px solid #000;
    border-right: 1px solid #000;
  }
  .theo-pip-overlay {
    display: none;
  }
  .theo-pip:not(.vjs-fullscreen) .theo-player-wrapper {
    position: fixed !important;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin {
    background-color: #757575;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .theo-control-bar-shadow {
    display: none;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-control:before,
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .theo-close-button:before {
    text-shadow:
      0 0 1px #000,
      0 0 1px #000,
      0 0 1px #000,
      0 0 1px #000,
      0 0 1px #000;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-control,
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-time-divider {
    display: none;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-play-control,
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-mute-control,
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-fullscreen-control,
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .theo-pip-close {
    display: block;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .vjs-custom-control-spacer {
    display: block;
    -webkit-box-flex: 1;
    -webkit-flex: auto;
    -moz-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin .theo-pip-close {
    opacity: 1;
    -webkit-transition: opacity 0.1s;
    -moz-transition: opacity 0.1s;
    transition: opacity 0.1s;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin.vjs-user-inactive.vjs-playing
    .theo-pip-close {
    opacity: 0;
    -webkit-transition: opacity 1s;
    -moz-transition: opacity 1s;
    transition: opacity 1s;
  }
  .theo-pip:not(.vjs-fullscreen).theoplayer-skin.theo-pip .theo-button-tooltip {
    margin-bottom: 0;
  }
  .theo-pip:not(.vjs-fullscreen).theo-pip-top-left .theo-player-wrapper {
    right: auto !important;
    bottom: auto !important;
    -webkit-animation: theo-pip-top-left 0.3s forwards;
    -moz-animation: theo-pip-top-left 0.3s forwards;
    animation: theo-pip-top-left 0.3s forwards;
  }
  .theo-pip:not(.vjs-fullscreen).theo-pip-top-right .theo-player-wrapper {
    left: auto !important;
    bottom: auto !important;
    -webkit-animation: theo-pip-top-right 0.3s forwards;
    -moz-animation: theo-pip-top-right 0.3s forwards;
    animation: theo-pip-top-right 0.3s forwards;
  }
  .theo-pip:not(.vjs-fullscreen).theo-pip-bottom-left .theo-player-wrapper {
    top: auto !important;
    right: auto !important;
    -webkit-animation: theo-pip-bottom-left 0.3s forwards;
    -moz-animation: theo-pip-bottom-left 0.3s forwards;
    animation: theo-pip-bottom-left 0.3s forwards;
  }
  .theo-pip:not(.vjs-fullscreen) .theo-player-wrapper,
  .theo-pip:not(.vjs-fullscreen).theo-pip-bottom-right .theo-player-wrapper {
    top: auto !important;
    left: auto !important;
    -webkit-animation: theo-pip-bottom-right 0.3s forwards;
    -moz-animation: theo-pip-bottom-right 0.3s forwards;
    animation: theo-pip-bottom-right 0.3s forwards;
  }
  .theo-pip:not(.vjs-fullscreen) .theo-pip-overlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0;
  }
  .theo-pip:not(.vjs-fullscreen) .theo-pip-overlay .theo-pip-overlay-text {
    position: absolute;
    left: 35px;
    right: 35px;
    bottom: 4em;
    font-size: 130%;
    font-weight: 500;
    opacity: 0.7;
  }
  @-webkit-keyframes theo-pip-bottom-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      right: 1.5em;
      bottom: 1.5em;
    }
  }
  @-moz-keyframes theo-pip-bottom-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      right: 1.5em;
      bottom: 1.5em;
    }
  }
  @keyframes theo-pip-bottom-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      right: 1.5em;
      bottom: 1.5em;
    }
  }
  @-webkit-keyframes theo-pip-bottom-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      left: 1.5em;
      bottom: 1.5em;
    }
  }
  @-moz-keyframes theo-pip-bottom-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      left: 1.5em;
      bottom: 1.5em;
    }
  }
  @keyframes theo-pip-bottom-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      left: 1.5em;
      bottom: 1.5em;
    }
  }
  @-webkit-keyframes theo-pip-top-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      right: 1.5em;
    }
  }
  @-moz-keyframes theo-pip-top-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      right: 1.5em;
    }
  }
  @keyframes theo-pip-top-right {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      right: 1.5em;
    }
  }
  @-webkit-keyframes theo-pip-top-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      left: 1.5em;
    }
  }
  @-moz-keyframes theo-pip-top-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      left: 1.5em;
    }
  }
  @keyframes theo-pip-top-left {
    to {
      width: 320px;
      height: 180px;
      z-index: 1000000000;
      top: 1.5em;
      left: 1.5em;
    }
  }
  .vjs-button.theo-related-button {
    cursor: pointer;
    -webkit-box-ordinal-group: 21;
    -webkit-order: 20;
    -moz-box-ordinal-group: 21;
    -ms-flex-order: 20;
    order: 20;
  }
  .theoplayer-skin:not(.theo-related-available)
    .vjs-button.theo-related-button {
    display: none;
  }
  .theo-related {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    top: 0;
  }
  .theoplayer-skin:not(.theo-related-showing) .theo-related {
    visibility: hidden;
  }
  .theoplayer-skin:not(.theo-related-showing)
    .theo-related
    .theo-overlay-panel {
    opacity: 0;
    top: 50%;
  }
  .theoplayer-skin.theo-related-showing .theo-button-tooltip {
    display: none;
  }
  .theo-related-grid {
    width: 100%;
    height: auto;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-flow: row wrap;
    -moz-box-orient: horizontal;
    -moz-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-content: flex-start;
    -ms-flex-line-pack: start;
    align-content: flex-start;
  }
  .theo-related-grid .theo-related-grid-tile {
    -webkit-box-flex: 1;
    -webkit-flex: auto;
    -moz-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
    padding: 0;
    border: 1px solid #000;
    position: relative;
  }
  .theo-related-grid
    .theo-related-grid-tile:hover
    .theo-related-grid-tile-content
    .theo-related-grid-tile-title,
  .theo-related-grid
    .theo-related-grid-tile:hover
    .theo-related-grid-tile-content
    .theo-related-grid-tile-duration {
    color: #ebebeb;
    background-color: rgba(0, 0, 0, 0.85);
  }
  .theo-related-grid
    .theo-related-grid-tile:hover
    .theo-related-grid-tile-content
    .theo-related-grid-tile-image {
    opacity: 1;
  }
  .theo-related-grid .theo-related-grid-tile .theo-related-grid-tile-content {
    width: 100%;
    padding-bottom: 56.25%;
    background-size: cover;
    display: block;
    color: #cdcdcd;
  }
  .theo-related-grid
    .theo-related-grid-tile
    .theo-related-grid-tile-content
    .theo-related-grid-tile-image {
    height: 100%;
    width: 100%;
    position: absolute;
    background-size: cover;
    opacity: 0.85;
    -webkit-transition: opacity 0.3s;
    -moz-transition: opacity 0.3s;
    transition: opacity 0.3s;
  }
  .theo-related-grid
    .theo-related-grid-tile
    .theo-related-grid-tile-content
    .theo-related-grid-tile-title,
  .theo-related-grid
    .theo-related-grid-tile
    .theo-related-grid-tile-content
    .theo-related-grid-tile-duration {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    padding: 0.4em 0.6em;
    -webkit-transition:
      background-color 0.3s,
      color 0.3s;
    -moz-transition:
      background-color 0.3s,
      color 0.3s;
    transition:
      background-color 0.3s,
      color 0.3s;
  }
  .theo-related-grid
    .theo-related-grid-tile
    .theo-related-grid-tile-content
    .theo-related-grid-tile-title {
    bottom: 0;
    line-height: 1.3em;
    width: 100%;
    border-bottom: 0.2em solid transparent;
  }
  .theo-related-grid
    .theo-related-grid-tile
    .theo-related-grid-tile-content
    .theo-related-grid-tile-duration {
    top: 0;
    left: 0;
    border-bottom-right-radius: 3px;
  }
  .theo-1-item-grid .theo-related-grid-tile {
    width: 100%;
  }
  .theo-size-xs.theo-2-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-3-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-4-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-6-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-8-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-9-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-12-item-grid .theo-related-grid-tile,
  .theo-size-xs.theo-15-item-grid .theo-related-grid-tile {
    width: 50%;
  }
  .theo-size-xs.theo-3-item-grid .theo-related-grid-tile:nth-child(n + 3) {
    display: none;
  }
  .theo-size-xs.theo-6-item-grid .theo-related-grid-tile:nth-child(n + 5),
  .theo-size-xs.theo-8-item-grid .theo-related-grid-tile:nth-child(n + 5),
  .theo-size-xs.theo-9-item-grid .theo-related-grid-tile:nth-child(n + 5),
  .theo-size-xs.theo-12-item-grid .theo-related-grid-tile:nth-child(n + 5),
  .theo-size-xs.theo-15-item-grid .theo-related-grid-tile:nth-child(n + 5) {
    display: none;
  }
  .theo-size-s.theo-2-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-4-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-2-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-4-item-grid .theo-related-grid-tile {
    width: 50%;
  }
  .theo-size-s.theo-3-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-6-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-8-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-9-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-12-item-grid .theo-related-grid-tile,
  .theo-size-s.theo-15-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-3-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-6-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-8-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-9-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-12-item-grid .theo-related-grid-tile,
  .theo-size-m.theo-15-item-grid .theo-related-grid-tile {
    width: 33.33%;
  }
  .theo-size-s.theo-8-item-grid .theo-related-grid-tile:nth-child(n + 7),
  .theo-size-s.theo-12-item-grid .theo-related-grid-tile:nth-child(n + 7),
  .theo-size-s.theo-15-item-grid .theo-related-grid-tile:nth-child(n + 7),
  .theo-size-m.theo-8-item-grid .theo-related-grid-tile:nth-child(n + 7),
  .theo-size-m.theo-12-item-grid .theo-related-grid-tile:nth-child(n + 7),
  .theo-size-m.theo-15-item-grid .theo-related-grid-tile:nth-child(n + 7) {
    display: none;
  }
  .theo-size-l.theo-2-item-grid .theo-related-grid-tile,
  .theo-size-l.theo-4-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-2-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-4-item-grid .theo-related-grid-tile {
    width: 50%;
  }
  .theo-size-l.theo-3-item-grid .theo-related-grid-tile,
  .theo-size-l.theo-6-item-grid .theo-related-grid-tile,
  .theo-size-l.theo-9-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-3-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-6-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-9-item-grid .theo-related-grid-tile {
    width: 33.33%;
  }
  .theo-size-l.theo-8-item-grid .theo-related-grid-tile,
  .theo-size-l.theo-12-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-8-item-grid .theo-related-grid-tile,
  .theo-size-xl.theo-12-item-grid .theo-related-grid-tile {
    width: 25%;
  }
  .theo-size-l.theo-15-item-grid .theo-related-grid-tile {
    width: 25%;
  }
  .theo-size-l.theo-15-item-grid .theo-related-grid-tile:nth-child(n + 13) {
    display: none;
  }
  .theo-size-xl.theo-15-item-grid .theo-related-grid-tile {
    width: 20%;
  }
  .vjs-button.theo-social-button {
    cursor: pointer;
    -webkit-box-ordinal-group: 11;
    -webkit-order: 10;
    -moz-box-ordinal-group: 11;
    -ms-flex-order: 10;
    order: 10;
  }
  .theoplayer-skin:not(.theo-social-available) .vjs-button.theo-social-button {
    display: none;
  }
  .theo-social {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    top: 0;
  }
  .theoplayer-skin:not(.theo-social-showing) .theo-social {
    visibility: hidden;
  }
  .theoplayer-skin:not(.theo-social-showing) .theo-social .theo-overlay-panel {
    opacity: 0;
    top: 50%;
  }
  .theoplayer-skin.theo-social-showing .theo-button-tooltip {
    display: none;
  }
  .theo-social .theo-social-container {
    width: 60%;
    max-width: 750px;
  }
  .theo-social
    .theo-social-container
    .theo-social-icon-container
    .theo-social-text-container {
    width: 100%;
  }
  .theo-social .theo-social-container .theo-social-icon-container {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .theo-social
    .theo-social-container
    .theo-social-icon-container
    .theo-social-iconurl {
    margin: 0.5em 0.5em 0.5em 0;
    min-width: 25px;
    min-height: 25px;
    width: 7%;
  }
  .theo-social
    .theo-social-container
    .theo-social-icon-container
    .theo-social-iconurl
    img {
    width: 100%;
    height: auto;
  }
  .theo-social
    .theo-social-container
    .theo-social-text-container
    .theo-social-content-container {
    padding: 0.7em;
    margin: 0.5em;
    max-height: 5em;
    text-overflow: ellipsis;
    font-family: monospace;
    font-size: 1.1em;
    line-height: 1.1em;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
    -webkit-user-select: all;
    -moz-user-select: all;
    -ms-user-select: all;
    user-select: all;
    cursor: copy;
  }
  .theo-social
    .theo-social-container
    .theo-social-text-container
    .theo-social-content-container:hover {
    background-color: rgba(54, 54, 54, 0.9);
  }
  .theo-social
    .theo-social-container
    .theo-social-text-container
    .theo-social-texturl
    a {
    color: #fff;
    font-style: italic;
  }
  .theo-social .theo-social-container .theo-social-label {
    font-family: monospace;
    display: inline-block;
    padding: 0.25em 0.5em;
    margin-bottom: 0;
  }
  .theo-social.theo-size-xs .theo-social-container {
    width: 90%;
  }
  .theo-social.theo-size-xs .theo-social-container .theo-social-label {
    display: none;
  }
  .theo-social.theo-size-xs
    .theo-social-container
    .theo-social-content-container {
    padding: 0.4em;
    font-size: 1em;
    white-space: pre;
  }
  .theo-upnext-panel {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    visibility: hidden;
  }
  .theo-upnext-panel .theo-upnext-panel-content {
    color: #fff;
    background-color: rgba(20, 20, 20, 0.85);
  }
  .theo-upnext-panel .theo-upnext-panel-content .theo-upnext-panel-image {
    height: 100%;
    background-size: cover;
    position: absolute;
    width: 100%;
  }
  .theo-upnext-panel
    .theo-upnext-panel-content
    .theo-upnext-panel-autoplay
    svg {
    cursor: pointer;
    display: block;
    width: 20%;
    height: auto;
    max-height: 100%;
    padding: 1em 0;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .theo-upnext-panel
    .theo-upnext-panel-content
    .theo-upnext-panel-autoplay
    svg
    .theo-play-svg-circle {
    stroke-dasharray: 458.6725274241;
    stroke-dashoffset: 458.6725274241;
    -webkit-transition: stroke-dashoffset 1s linear;
    -moz-transition: stroke-dashoffset 1s linear;
    transition: stroke-dashoffset 1s linear;
  }
  .theo-upnext-panel .theo-upnext-panel-content .theo-upnext-panel-text {
    padding: 8%;
    text-align: center;
    width: 100%;
    position: absolute;
    text-shadow: 0px 2px 4px #000;
  }
  .theo-upnext-panel
    .theo-upnext-panel-content
    .theo-upnext-panel-text
    .theo-upnext-panel-upnext {
    font-weight: bold;
    margin-bottom: 0.5em;
    font-size: 1.7em;
  }
  .theo-upnext-panel
    .theo-upnext-panel-content
    .theo-upnext-panel-text
    .theo-upnext-panel-title {
    overflow: hidden;
    height: 3em;
    font-size: 1.8em;
  }
  .theo-upnext-panel.theo-size-s
    .theo-upnext-panel-content
    .theo-upnext-panel-text
    .theo-upnext-panel-title {
    height: 2em;
  }
  .theo-upnext-panel.theo-size-xs
    .theo-upnext-panel-content
    .theo-upnext-panel-text
    .theo-upnext-panel-title {
    height: 1em;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-panel-showing
    .theo-upnext-panel {
    visibility: visible;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-panel-showing
    .vjs-button.theo-related-button {
    display: none;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-panel-showing
    .vjs-button.theo-social-button {
    display: none;
  }
  .theo-upnext-bar.theo-upnext-vdms {
    cursor: default;
  }
  .theo-upnext-bar {
    width: 33%;
    height: 15%;
    position: absolute;
    right: 0;
    font-size: 1.25em;
    bottom: 3.5em;
    overflow: hidden;
    max-width: 20em;
    max-height: 5em;
    min-height: 3em;
    min-width: 10em;
    cursor: pointer;
  }
  .theo-upnext-bar .theo-upnext-bar-content {
    text-decoration: none;
    color: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 100%;
    width: 0;
    background-color: rgba(20, 20, 20, 0.85);
    -webkit-transition: none;
    -moz-transition: none;
    transition: none;
    padding-right: 0.8em;
    cursor: inherit;
  }
  .theo-upnext-bar .theo-upnext-bar-content .theo-upnext-bar-image {
    height: 100%;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-size: cover;
    position: relative;
    width: 0;
  }
  .theo-upnext-bar
    .theo-upnext-bar-content
    .theo-upnext-bar-image
    .theo-upnext-bar-duration {
    display: none;
    bottom: 0;
    right: 0;
    border-top-left-radius: 3px;
    position: absolute;
    color: #ebebeb;
    background-color: rgba(20, 20, 20, 0.85);
    padding: 0.4em 0.6em;
    font-size: 0.8em;
  }
  .theo-upnext-bar .theo-upnext-bar-content .theo-upnext-bar-text {
    margin: 0.5em 0 0.5em 0.5em;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: 0.8em;
    width: 0;
  }
  .theo-upnext-bar
    .theo-upnext-bar-content
    .theo-upnext-bar-text
    .theo-upnext-bar-upnext {
    font-weight: bold;
    margin-bottom: 0.5em;
  }
  .theo-upnext-bar
    .theo-upnext-bar-content
    .theo-upnext-bar-text
    .theo-upnext-bar-title {
    overflow: hidden;
    height: 3em;
  }
  .theo-upnext-bar.theo-size-s
    .theo-upnext-bar-content
    .theo-upnext-bar-text
    .theo-upnext-bar-title {
    height: 2em;
  }
  .theo-upnext-bar.theo-size-xs
    .theo-upnext-bar-content
    .theo-upnext-bar-text
    .theo-upnext-bar-title {
    height: 1em;
  }
  .theoplayer-skin:not(.theo-upnext-bar-showing) .theo-upnext-bar {
    pointer-events: none;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-bar-showing.vjs-user-inactive.vjs-playing:not(
      .theo-menu-opened
    )
    .theo-upnext-bar {
    bottom: 1em;
    -webkit-transition: bottom 0.1s ease-out 0.6s;
    -moz-transition: bottom 0.1s ease-out 0.6s;
    transition: bottom 0.1s ease-out 0.6s;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-bar-showing
    .theo-upnext-bar
    .theo-upnext-bar-content {
    left: 0;
    width: 100%;
    -webkit-transition: left 0.2s ease-in-out;
    -moz-transition: left 0.2s ease-in-out;
    transition: left 0.2s ease-in-out;
  }
  .theoplayer-skin.vjs-has-started.theo-upnext-bar-showing
    .theo-upnext-bar
    .theo-upnext-bar-image
    .theo-upnext-bar-duration {
    display: inline;
  }
  .theoplayer-skin.theo-mobile .theo-upnext-bar {
    bottom: 5em;
  }
  .theoplayer-skin.theo-mobile
    .theo-upnext-bar
    .theo-upnext-bar-content
    .theo-upnext-bar-image
    .theo-upnext-bar-duration {
    padding: 0.2em 0.3em;
    font-size: 0.7em;
  }
  .theo-vdms-content-notification-bar {
    position: absolute;
    top: 0;
    width: 100%;
    text-align: center;
  }
  .theo-vdms-content-notification-bar .theo-vdms-content-notification {
    width: 100%;
    font-size: 1.25em;
    color: #fff;
    background-color: rgba(51, 51, 51, 0.6);
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .theo-vdms-content-notification-bar
    .theo-vdms-content-notification
    .theo-vdms-content-notification-thumbnail {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
    object-fit: contain;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
  .theo-vdms-content-notification-bar
    .theo-vdms-content-notification
    .theo-vdms-content-notification-description {
    -webkit-box-flex: 2;
    -webkit-flex: 2;
    -moz-box-flex: 2;
    -ms-flex: 2;
    flex: 2;
    margin: 1em;
  }
  .theo-vdms-content-notification-bar
    .theo-vdms-content-notification
    .theo-vdms-content-notification-countdown {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin: 1em 1em 1em 0;
  }
  .theoplayer-skin .theo-overlay-panel {
    background-color: #000;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    top: 0;
    opacity: 1;
    -webkit-transition:
      opacity 0.2s cubic-bezier(0.4, 0, 1, 1),
      top 0.2s cubic-bezier(0.4, 0, 1, 1);
    -moz-transition:
      opacity 0.2s cubic-bezier(0.4, 0, 1, 1),
      top 0.2s cubic-bezier(0.4, 0, 1, 1);
    transition:
      opacity 0.2s cubic-bezier(0.4, 0, 1, 1),
      top 0.2s cubic-bezier(0.4, 0, 1, 1);
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .theoplayer-skin .theo-overlay-panel .theo-close-button {
    display: block;
    width: 1.5em;
    height: 1.5em;
    margin: 0.75em;
    padding: 0;
    border-radius: 50%;
    line-height: 1em;
    text-align: center;
    cursor: pointer;
  }
  .theoplayer-skin .theo-overlay-panel .theo-close-button:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: -0.75em;
  }
  .theo-360-compass {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    margin: 0.5em;
    font-size: 26px;
    width: 1em;
    height: 1em;
    border: 0.025em solid #fff;
    border-radius: 100%;
    pointer-events: none;
  }
  .theoplayer-skin.vjs-error .theo-360-compass,
  .theoplayer-skin:not(.vjs-has-started) .theo-360-compass {
    display: none;
  }
  .theo-360-compass:before,
  .theo-360-compass:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
  }
  .theo-360-compass:before {
    top: 50%;
    left: 50%;
    border: 0.075em solid #fff;
    border-radius: 100%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .theo-360-compass:after {
    top: 0;
    left: 50%;
    border-left: 0.1em solid transparent;
    border-right: 0.1em solid transparent;
    border-bottom: 0.1em solid #fff;
    -webkit-transform: translate(-50%, -100%);
    -moz-transform: translate(-50%, -100%);
    transform: translate(-50%, -100%);
    -webkit-transform-origin: 50% 100%;
    -moz-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }
  .theo-360-fov {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    width: 50%;
    height: 50%;
    -webkit-transform-origin: 100% 100%;
    -moz-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    -webkit-transform: scale(0.875) rotate(40deg) skew(-10deg);
    -moz-transform: scale(0.875) rotate(40deg) skew(-10deg);
    transform: scale(0.875) rotate(40deg) skew(-10deg);
  }
  .theo-360-fov:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: 0.35em solid rgba(255, 255, 255, 0.75);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 100%;
    -webkit-transform: skew(10deg);
    -moz-transform: skew(10deg);
    transform: skew(10deg);
  }
  .theo-upcoming-ad-notification {
    width: auto;
    height: auto;
    position: absolute;
    margin-right: 1em;
    right: 0;
    font-size: 1.25em;
    bottom: 3.5em;
    overflow: hidden;
    min-width: 10em;
    display: none;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -moz-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    z-index: 0;
  }
  @media (max-width: 375px) {
    .theo-upcoming-ad-notification {
      font-size: 1.15em;
      bottom: 3.6em;
    }
  }
  .theo-upcoming-ad-notification-text {
    color: #fff;
    height: 100%;
    text-shadow: 0.1em 0.1em 0.2em #000;
  }
  .theo-upcoming-ad-notification-show-browser {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
  }
  .theo-upcoming-ad-notification-show-mobile {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    bottom: auto;
    top: 1em;
    left: 1em;
    right: auto;
    font-size: 1.05em;
    margin: 0;
  }
  .vjs-user-inactive.vjs-playing
    .theo-upcoming-ad-notification.theo-upcoming-ad-notification-show-browser {
    bottom: 1em;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
  }
`;
